import React, { useState, useRef, useEffect } from "react";
import { Observer } from "mobx-react";
import {
  MdKeyboardArrowUp,
  MdKeyboardBackspace,
  MdOutlineArrowBackIosNew,
  MdOutlineMic,
  MdOutlineMicOff,
  MdOutlineRefresh,
  MdOutlineVideocam,
  MdOutlineVideocamOff,
  MdOutlineVolumeUp,
  MdVolumeDown,
  MdVolumeUp,
  MdLightMode,
  MdStopCircle,
} from "react-icons/md";
import { BsFillSendFill } from "react-icons/bs";
import { startAdvancedProxyDetection } from "../../proxy-detection/proxyDetection";
import userDefault from "../../assests/userdefaultpic.jpeg";
import {
  AiFillInfoCircle,
  AiOutlineCheckCircle,
  AiOutlineClockCircle,
  AiOutlineCloseSquare,
  AiOutlineMessage,
  AiOutlineRobot,
  AiOutlineInfoCircle,
  AiOutlineInfo,
  AiOutlineQuestion,
  AiOutlineBug,
} from "react-icons/ai";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import Speech from "speak-tts";
import useSpeechToText from "react-hook-speech-to-text";
import axios from "axios";
import {
  apiLink,
  audioOptions,
  interviewCompletedSequence,
  isMobileView,
  loginWarningImage,
} from "../../helpers/constantVariables";
import TypewriterText from "../reusble_components/typeWritingText";
import InterviewFeedback from "../reusble_components/interviewFeedback";
import { useNavigate } from "react-router-dom";
import { useStores } from "../../store/index";
import SubmitButton from "./submitButton";
import RecordingSection from "./recording";
import Timer from "./timer";
import { UserVideo } from "./userVideo";
import LucyVoice from "./lucyVoice";
import MuteButton from "./muteButton";
import { GetMoreCreditsPopUp, RedeemCoupon } from "../dashboard/basicDetails";
import { PurchaseCredits } from "../dashboard/creditPoints";
import RequestPermission from "./requestPermission";
import TestMedia from "./testMedia";
import {
  IoCheckmarkCircleOutline,
  IoSettingsOutline,
  IoVideocamOffOutline,
  IoVideocamOutline,
} from "react-icons/io5";
import Compiler from "../dashboard/compiler";
import image from "../../assests/nointerviewshere.png";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import {
  FaChartBar,
  FaCode,
  FaHeadSideCough,
  FaMicrophone,
  FaTags,
  FaUser,
  FaUserTie,
  FaVideo,
} from "react-icons/fa";
import { uploadFileToAzure } from "../../services/azure";
import {
  getLogoBySubdomain,
  getclusterbyDomain,
} from "../../services/white_label";
import { removeLucy } from "../../services/reusable";
import AzureSpeechToText from "../azure/speech_to_text";
import { interviewsList } from "../../helpers/constantVariables";
import Popup from "../reusble_components/popup";
import Tooltip from "../reusble_components/tooltip";
import { setDataToLocalStorage } from "../../services/localStorage";
import ReferAndEarn from "../dashboard/ReferAndEarn";
import HelpCenter from "../reusble_components/helpCenter";
import Pako from "pako";
import { apiGet, apiPostPut } from "../../api/api_methods";
import html2canvas from "html2canvas";

import { RiRecordCircleLine } from "react-icons/ri";
import ScreenShareErrorCard from "../reusble_components/notifications/ScreenShareCardError";
import { TbKeyboardOff } from "react-icons/tb";
import UploadLoader from "../reusble_components/uploadLoader";
import Clock from "../reusble_components/timer";
import user from "../../assests/userdefaultpic.jpeg";
import ImageCapture from "./imageCapture";
import ChatComponent from "../UI/ChatComponent";
import {
  Flex,
  Card,
  Avatar,
  Button,
  IconButton,
  Box,
  TextArea,
  Theme,
  Separator,
  Text,
  Switch,
} from "@radix-ui/themes";
import {
  MdKeyboardArrowLeft,
  MdSettings,
  MdCode,
  MdOutlineDarkMode,
  MdOutlineLightMode,
  MdOpenInFull,
} from "react-icons/md";
import { Dialog } from "@radix-ui/themes";
import AudioVisualizer from "../UI/AudioVisualizer";
import { BiExit } from "react-icons/bi";
import Joyride from "react-joyride";
import IssueReportPopup from "./IssueReportPopup";
import ConfirmationPopup from "../UI/ConfirmationPopup";
import copyPasteImg from "../../assests/Copy.png";
import multiFaceImg from "../../assests/MultiFacee.png";
import tabChangeImg from "../../assests/Tab.png";
import multiVoiceImg from "../../assests/Voice.png";
import faceOutviewImg from "../../assests/Face.png";

// Custom hook for copy-paste restriction
const useRestrictCopyPaste = (isActive) => {
  const { InterviewStore } = useStores();

  useEffect(() => {
    if (!isActive) return;

    const preventPaste = (e) => {
      e.preventDefault();

      // Show notification instead of alert
      InterviewStore.setNotificationText(
        "Copying, cutting, and pasting are disabled.",
      );
      InterviewStore.setNotificationIcon(
        <div className="relative text-white bg-primary">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </div>,
      );
      InterviewStore.setShowNotification(true);
    };

    // Add event listeners for copy, cut, and paste
    window.addEventListener("copy", preventPaste);
    window.addEventListener("cut", preventPaste);
    window.addEventListener("paste", preventPaste);

    // Cleanup function to remove event listeners when the component unmounts or isActive becomes false
    return () => {
      window.removeEventListener("copy", preventPaste);
      window.removeEventListener("cut", preventPaste);
      window.removeEventListener("paste", preventPaste);
    };
  }, [isActive, InterviewStore]); // Dependency on isActive and InterviewStore ensures the effect runs when interview state changes
};

export default function InterviewScreen(
  {
    // name,
    // technology,
    // levelOfInterview,
    // noOfQuestions,
    // onBack,
  },
) {
  // const customSettings = JSON.parse(localStorage.getItem("customSettings"));
  const navigate = useNavigate();
  const speech = new Speech();
  speech
    .init({
      volume: 1,
      lang: "en-US",
      rate: 1,
      pitch: 1,
      // voice: "Google UK English Female",
      // splitSentences: true,
      listeners: {
        onvoiceschanged: (voices) => {
          console.log("Event voiceschanged", voices);
        },
      },
    })
    .then((data) => {
      // The "data" object contains the list of available voices and the voice synthesis params
      console.log("Speech is ready, voices are available", data);
    })
    .catch((e) => {
      console.error("An error occured while initializing : ", e);
    });

  /* ----------- speech recognition section methods for mobile view ----------- */
  const {
    error,
    interimResult,
    isRecording,
    results,
    startSpeechToText,
    stopSpeechToText,
  } = useSpeechToText({
    continuous: true,
    useLegacyResults: false,
  });

  const { InterviewStore, PopupStore } = useStores();

  const [activeTab, setActiveTab] = useState("tab1");

  const [name, setName] = useState("");
  const [levelOfInterview, setLevelOfInterview] = useState("");
  const [technology, setTechnology] = useState("");
  const [companyurl, setCompanyUrl] = useState("");
  const [noOfQuestions, setNoOfQuestions] = useState("");
  const [whoPay, setWhoPay] = useState();
  const continueInterviewId = new URLSearchParams(window.location.search).get(
    "continue",
  );

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    localStorage.removeItem("userImage");
    const name1 = new URLSearchParams(window.location.search).get("name");
    const levelOfInterview1 = new URLSearchParams(window.location.search).get(
      "level",
    );
    const technology1 = new URLSearchParams(window.location.search).get(
      "technology",
    );
    const noOfQuestions1 = new URLSearchParams(window.location.search).get(
      "question",
    );
    const companyurl = new URLSearchParams(window.location.search).get(
      "companyurl",
    );
    console.log(
      "detailsssss",
      name1,
      levelOfInterview1,
      technology1,
      noOfQuestions1,
    );

    setName(name1);
    setLevelOfInterview(levelOfInterview1);
    setTechnology(technology1);
    setNoOfQuestions(noOfQuestions1);

    if (error) {
      alert(
        `Web Speech API is not available in this browser ${error.toString()} 🤷‍`,
      );
    }
  }, []);

  // const url = window.location.href;

  // if (!url.includes("/dashboard/report")) {
  //   console.log("url", url);
  //   window.addEventListener("beforeunload", (event) => {
  //     event.preventDefault();
  //     event.returnValue = "Are you sure you want to leave the interview?";
  //   });
  // }

  const tabsComponent = () => {
    const handleTabClick = (tab) => {
      setActiveTab(tab);
    };

    return (
      <div className=" w-full h-fit mx-auto">
        <HelpCenter />

        <div className="flex w-full p-2 lg:p-3 bg-slate-50 rounded-xl">
          <button
            className={`py-3 px-4 lg:text-xl text-sm w-[50px] gil-bold rounded-md mr-2 block md:hidden lg:hidden cursor-default ${
              activeTab === "tab1"
                ? "bg-primary text-white"
                : "bg-primary2 text-gray-700"
            }`}
            onClick={() => {
              InterviewStore.toggleScreen(false);
            }}
          >
            <MdOutlineArrowBackIosNew className="w-[20px] h-[20px] text-slate-100 p-0  " />
          </button>
          <button
            className={`py-3 px-4 lg:text-xl text-sm w-1/2 gil-bold cursor-default rounded-md ${
              activeTab === "tab1"
                ? "bg-primary text-white"
                : "bg-gray-50 text-gray-700"
            }`}
            onClick={() => handleTabClick("tab1")}
          >
            Conversation
          </button>
          <button
            className={`py-3 px-4 lg:text-xl text-sm w-1/2 gil-bold ml-2 rounded-md ${
              activeTab === "tab2"
                ? "bg-primary text-white"
                : "bg-gray-50 text-gray-700"
            }`}
            onClick={() => handleTabClick("tab2")}
          >
            Interview details
          </button>
        </div>
      </div>
    );
  };

  const InterviewDetailsComponent = () => {
    const interviewData = JSON.parse(localStorage.getItem("interviewDetails"));

    const getInterviewTitle = (id) => {
      const interview = interviewsList.find((item) => item.id === id);
      return interview ? interview.title : "-";
    };

    return (
      <div
        id="interview-details"
        className="flex flex-col justify-center items-start h-full w-[90%] mx-auto"
      >
        <div className="flex items-center mb-4">
          <FaUser className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Interviewee:</span> {interviewData?.name}
          </p>
        </div>
        <div className="flex items-center mb-4">
          <FaUserTie className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Interview Type:</span>{" "}
            {getInterviewTitle(interviewData?.interviewId)}
          </p>
        </div>
        <div className="flex items-center mb-4">
          <FaUserTie className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Interviewer: Lucy</span>
          </p>
        </div>

        {interviewData?.technology && (
          <div className="flex items-center mb-4">
            <FaTags className="mr-2 text-gray-500" />
            <p>
              <span className="gil-bold">Topic:</span>{" "}
              {interviewData?.technology || interviewData?.role}
            </p>
          </div>
        )}

        <div className="flex items-center mb-4">
          <FaMicrophone className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Microphone:</span> Allowed
          </p>
        </div>
        <div className="flex items-center mb-4">
          <FaVideo className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Video:</span> Allowed
          </p>
        </div>
        <div className="flex items-center">
          <FaChartBar className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Level:</span>{" "}
            {interviewData?.levelOfInterview}
          </p>
        </div>
      </div>
    );
  };

  const redirectToSignupPageWithCurrentUrl = () => {
    const currentPath = window.location.href;

    // set currentPath in local storage
    setDataToLocalStorage("redirectUrl", currentPath);

    const signupUrl = `/signup`;

    console.log(signupUrl);

    navigate(signupUrl);
  };

  // Add warning for browser back button and page refresh during interview
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (
        InterviewStore.isInterviewStarted &&
        !InterviewStore.isInterviewCompleted
      ) {
        const confirmationMessage =
          "Are you sure you want to leave the interview? Your progress will be lost.";
        e.preventDefault();
        e.returnValue = confirmationMessage;
        return confirmationMessage;
      }
    };

    const handlePopState = (e) => {
      if (
        InterviewStore.isInterviewStarted &&
        !InterviewStore.isInterviewCompleted
      ) {
        setLeaveCallback(
          () => () =>
            window.history.pushState(null, null, window.location.href),
        );
        setShowLeaveConfirm(true);
      }
    };

    // Add event listeners
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    // Push current state to enable popstate detection
    if (
      InterviewStore.isInterviewStarted &&
      !InterviewStore.isInterviewCompleted
    ) {
      window.history.pushState(null, null, window.location.href);
    }

    // Cleanup
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [InterviewStore.isInterviewStarted, InterviewStore.isInterviewCompleted]);

  const setTechnology1 = (tech) => {
    setTechnology(tech);
  };

  const setName2 = (name) => {
    setName(name);
  };

  const handleImageCaptured = async (url) => {
    console.log("url", url);
    PopupStore.setImageCapture(false);
    localStorage.setItem("userImage", url);
    // InterviewStore.newProxy();
  };

  const [theme, setTheme] = useState("dark");

  const manualInterviewCompleted = async () => {
    // ask interviewee to is interview completed or not
    const response = window.confirm("Is interview completed?");

    if (response) {
      InterviewStore.setCameraNotification(false);
      InterviewStore.setNotificationText("Interview Stopped");
      InterviewStore.setNotificationIcon(
        <RiRecordCircleLine className="text-[#FA3532] text-xl" />,
      );
      InterviewStore.setShowNotification(true);
      InterviewStore.setIsInterviewCompleted(true);
      setTimeout(() => {}, 2000);
      InterviewStore.setIsInterviewCompleted(true);

      //setIsInterviewCompleted(true);
    }
  };
  const from = new URLSearchParams(window.location.search).get("from");
  const environment = new URLSearchParams(window.location.search).get(
    "environment",
  );

  const onBack = () => {
    if (from === "user-reaidy") {
      if (environment === "production") {
        return (window.location.href = "https://user.reaidy.io/");
      } else {
        return (window.location.href = "https://qa-user.reaidy.io/");
      }
    }
    navigate("/");
  };

  // Camera warning dialog using Radix UI

  const [showTour, setShowTour] = useState(false);
  const [tourRun, setTourRun] = useState(false);
  const [tourStepIndex, setTourStepIndex] = useState(0);

  // Product tour steps
  const tourSteps = [
    {
      target: "#start-interview-btn",
      content: "Click here to start your interview!",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: "#mute-btn",
      content: "Mute or unmute your microphone here.",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: "#camera-btn",
      content: "This is where you can see your camera feed.",
      placement: "bottom",
      disableBeacon: true,
    },

    // create a step for code editor button
    {
      target: "#code-editor-btn",
      content: "Access your code editor here.",
      placement: "bottom",
      disableBeacon: true,
    },

    // create a step for settings button
    {
      target: "#settings-btn",
      content: "Access your settings here.",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: "#conversation-panel",
      content: "This is where your conversation with the AI will appear.",
      placement: "left",
    },
    // create a step for theme button
    {
      target: "#theme-btn",
      title: "Theme",
      content: "Toggle the white and dark mode here.",
      placement: "bottom",
    },
    // create a step for noise cancellation button

    {
      target: "#issue-btn",
      title: "Facing an issue?",
      content:
        "If you are facing any issue, you can able to solve it from here.",
      placement: "bottom",
    },

    {
      target: "#issue-bt",
      title: "Facing an issue?",
      content:
        "If you are facing any issue, you can able to solve it from here.",
      placement: "bottom",
    },

    // Add more steps as needed
  ];

  // Always show tour on mount
  // useEffect(() => {
  //   setTourRun(true);
  //   setShowTour(true);
  // }, []);

  // Cleanup tour state when component unmounts
  useEffect(() => {
    return () => {
      closeTour();
    };
  }, []);

  // Monitor tour state changes for debugging
  useEffect(() => {
    console.log("Tour state changed:", { tourRun, showTour, tourStepIndex });
  }, [tourRun, showTour, tourStepIndex]);

  // Handle escape key and overlay clicks to close tour
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" && tourRun) {
        console.log("Escape key pressed - closing tour");
        closeTour();
      }
    };

    const handleOverlayClick = (event) => {
      // Check if the click is on the overlay (not on the tour tooltip)
      if (
        tourRun &&
        event.target.classList.contains("react-joyride__overlay")
      ) {
        console.log("Overlay clicked - closing tour");
        closeTour();
      }
    };

    if (tourRun) {
      console.log("Tour is running - adding event listeners");
      document.addEventListener("keydown", handleEscapeKey);
      document.addEventListener("click", handleOverlayClick);
    }

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
      document.removeEventListener("click", handleOverlayClick);
    };
  }, [tourRun]);

  // Function to manually close the tour
  const closeTour = () => {
    console.log("Closing tour - resetting state");
    setTourRun(false);
    setShowTour(false);
    setTourStepIndex(0);
  };

  // Function to start the tour
  const startTour = () => {
    console.log("Starting tour");
    // Ensure tour is properly reset before starting
    closeTour();
    // Use setTimeout to ensure state updates are processed
    setTimeout(() => {
      setTourRun(true);
      setShowTour(true);
      setTourStepIndex(0);
    }, 0);
  };

  // Handle tour callback
  const handleJoyrideCallback = (data) => {
    console.log("Joyride callback data:", data);
    const { status, index, type, action, size } = data;

    // Handle tour completion, skipping, ending, and closing
    if (
      status === "finished" ||
      status === "skipped" ||
      type === "tour:end" ||
      type === "close" ||
      action === "close"
    ) {
      console.log("Closing tour due to:", { status, type, action });
      closeTour();
      return;
    }

    // Handle next/back navigation in controlled mode
    if (type === "step:after") {
      if (action === "next" && index < size - 1) {
        setTourStepIndex(index + 1);
      } else if (action === "prev" && index > 0) {
        setTourStepIndex(index - 1);
      }
    }
  };

  // Add state for confirmation dialog at the top level of InterviewScreen
  const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);
  const [leaveCallback, setLeaveCallback] = useState(null);

  return (
    <Observer>
      {() => (
        <div className="w-[100vw] h-[100vh] gil-reg">
          {/* Product Tour Joyride */}
          <Joyride
            steps={tourSteps}
            run={tourRun}
            stepIndex={tourStepIndex}
            continuous
            showSkipButton
            showProgress
            showCloseButton
            styles={{
              options: {
                zIndex: 10000,
              },
            }}
            callback={handleJoyrideCallback}
            disableScrolling={true}
            disableOverlayClose={false}
            hideCloseButton={false}
            spotlightClicks={false}
            disableOverlay={false}
          />
          {/* Show Tour Button - Uncomment for testing */}
          {/* <button
            style={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 11000,
              background: "#FF6B00",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: "8px 16px",
              fontWeight: 600,
              cursor: "pointer",
              boxShadow: "0 2px 8px 0 rgba(0,0,0,0.18)",
            }}
            onClick={() => {
              startTour();
            }}
            aria-label="Show Product Tour"
          >
            Show Tour
          </button> */}
          <RequestPermission
            popUpInitialValue={PopupStore.requestPermission}
            handlePopup={() => {
              PopupStore.setRequestPermission(false);
            }}
            screenRecord={false}
          />
          {InterviewStore.showNotification && (
            <ScreenShareErrorCard
              text={InterviewStore.notificationText}
              icon={InterviewStore.notificationIcon}
              timer={InterviewStore.nottificationTimer}
              show={InterviewStore.showNotification}
            />
          )}

          <ImageCapture
            popUpInitialValue={PopupStore.imageCapture}
            handlePopup={() => {
              PopupStore.setImageCapture(false);
            }}
            onImageCaptured={handleImageCaptured}
          />

          <TestMedia
            popUPInitialValue={PopupStore.testMedia}
            // popUPInitialValue={false}
            handlePopUp={() => {
              PopupStore.setTestMedia(false);
              PopupStore.setShowPrecautions(true);
            }}
            handleTestCompleted={() => {
              PopupStore.setShowPrecautions(true);
            }}
            openingThroughSettings={PopupStore.testMediaOpeningThroughSettings}
          />

          {PopupStore.popup && (
            <Popup
              popUpInitialValue={PopupStore.popup}
              handlePopup={() => {
                PopupStore.setPopup(false);
              }}
              image={image}
              content="Your verification is under process"
              buttontext="check verification status"
              onClick={() => {
                alert("clicked");
              }}
            />
          )}

          {PopupStore.shareScreen && (
            <Popup
              popUpInitialValue={PopupStore.shareScreen}
              handlePopup={() => {
                PopupStore.setShareScreen(false);
              }}
              image={image}
              content="Please share the entire screen"
              buttontext="Got it"
              onClick={() => {
                InterviewStore.setLoading(false);
                PopupStore.setShareScreen(false);
              }}
            />
          )}

          {PopupStore.loginWarning && (
            <Popup
              popUpInitialValue={PopupStore.loginWarning}
              handlePopup={() => {
                PopupStore.setLoginWarning(false);
              }}
              image={loginWarningImage}
              content="Please signup to start interview"
              buttontext="Signup now"
              onClick={() => {
                redirectToSignupPageWithCurrentUrl();
                PopupStore.setLoginWarning(false);
              }}
            />
          )}

          <Compiler
            popUpInitialValue={PopupStore.compiler}
            handlePopup={() => {
              PopupStore.setCompiler(false);
            }}
          />

          {/* Mobile view component */}
          {/* <div className="h-full w-full flex flex-row items-center justify-center p-[5px] md:p-[2vw] lg:p-[2vw] md:hidden lg:hidden relative">
            <VideoCallSection
              technology={technology}
              setTechnology1={setTechnology1}
              companyurl={companyurl}
              name={name}
              setName2={setName2}
              levelOfInterview={levelOfInterview}
              noOfQuestions={noOfQuestions}
              store={InterviewStore}
              speech={speech}
              onBack={onBack}
              toggleMessageTab={() => InterviewStore.toggleScreen(true)}
              // new voice recognition props
              interimResult={interimResult}
              results={results}
              isRecording={isRecording}
              startSpeechToText={startSpeechToText}
              stopSpeechToText={stopSpeechToText}
              speechError={error}
              theme={theme}
            />

            {InterviewStore.showMessageTab && (
              <div className="w-[95%] h-[95%] bg-slate-200 p-[2vw] rounded-2xl mt-4 absolute inset-0 z-40 ">
                {/* {tabsComponent()} */}
          {/* <div className="h-[90%]">
                  <ChatComponent
                    chat={InterviewStore.chatHistory}
                    theme={theme}
                  />
                </div>
              </div>
            )}
          </div>  */}

          {/* web and laptop view component */}
          {/* <div className="h-full w-full hidden md:flex lg:flex flex-row items-center justify-center p-[5px] md:p-[1vw] lg:p-[1vw]">
            <VideoCallSection
              technology={technology}
              setTechnology1={setTechnology1}
              companyurl={companyurl}
              name={name}
              setName2={setName2}
              levelOfInterview={levelOfInterview}
              noOfQuestions={noOfQuestions}
              store={InterviewStore}
              speech={speech}
              onBack={onBack}
              // new voice recognition props
              interimResult={interimResult}
              results={results}
              isRecording={isRecording}
              startSpeechToText={startSpeechToText}
              stopSpeechToText={stopSpeechToText}
              speechError={error}
            />

            {interviewStatusSection(activeTab)}
          </div> */}
          <Theme
            appearance={theme}
            accentColor="orange"
            className="md:block lg:block"
            style={{
              background: theme === "dark" ? "black" : "#fff",
            }}
          >
            <Flex
              direction="column"
              style={{
                minHeight: "100vh",
                background: theme === "dark" ? "black" : "#fff",
                color: theme === "dark" ? "#fff" : "#222",
              }}
            >
              {/* Header */}
              <Flex
                align="center"
                justify="between"
                style={{
                  padding: 0,
                  height: window.innerWidth < 768 ? 50 : 64,
                  background: theme === "dark" ? "#18181b" : "#fff",
                  color: theme === "dark" ? "#fff" : "#222",
                  borderBottom: theme === "dark" ? "1px solid #232325" : "",
                  boxShadow:
                    theme === "dark" ? "" : "0 1px 4px 0 rgba(0,0,0,0.18)",
                  position: "relative",
                  zIndex: 0,
                }}
              >
                <IconButton
                  variant="ghost"
                  color="gray"
                  style={{ marginLeft: 24 }}
                  onClick={() => {
                    // Check if interview is in progress
                    if (
                      InterviewStore.isInterviewStarted &&
                      !InterviewStore.isInterviewCompleted
                    ) {
                      setLeaveCallback(() => onBack);
                      setShowLeaveConfirm(true);
                    } else {
                      onBack();
                    }
                  }}
                >
                  <MdKeyboardArrowLeft size={28} />
                </IconButton>
                <Dialog.Root open={InterviewStore.turnOffCamera}>
                  <Dialog.Content
                    style={{ maxWidth: 360, textAlign: "center" }}
                  >
                    <Dialog.Title>
                      You can't turn off the camera during the interview.
                    </Dialog.Title>
                    <Dialog.Description asChild>
                      <p className="mb-4" />
                    </Dialog.Description>
                    <Dialog.Close asChild>
                      <button
                        onClick={() => {
                          InterviewStore.setTurnOffCamera(false);
                        }}
                        className="px-4 py-2 bg-primary text-white rounded-lg mt-4"
                      >
                        OK
                      </button>
                    </Dialog.Close>
                  </Dialog.Content>
                </Dialog.Root>
                <div>
                  <Flex
                    direction="column"
                    gap="2"
                    align="center"
                    justify="center"
                  >
                    {InterviewStore.isInterviewCompleted &&
                      window.innerWidth > 768 &&
                      !InterviewStore.isVideoUploaded && (
                        <Card
                          variant="surface"
                          style={{
                            background: "#FFF8E1",
                            minWidth: 220,
                            padding: 0,
                          }}
                        >
                          <Flex align="center" gap="2" px="4" py="2">
                            <AiOutlineClockCircle
                              size="1.2rem"
                              style={{ color: "#FFA726" }}
                            />
                            <Text size="2" color="amber">
                              Your video is uploading...
                            </Text>
                          </Flex>
                        </Card>
                      )}
                    {InterviewStore.isVideoUploaded &&
                      window.innerWidth > 768 &&
                      InterviewStore.recordPermission && (
                        <Card
                          variant="surface"
                          style={{
                            background: "#E8F5E9",
                            minWidth: 220,
                            padding: 0,
                          }}
                        >
                          <Flex align="center" gap="2" px="4" py="2">
                            <AiOutlineCheckCircle
                              size="1.2rem"
                              style={{ color: "#43A047" }}
                            />
                            <Text size="2" color="green">
                              Your video is uploaded
                            </Text>
                          </Flex>
                        </Card>
                      )}
                  </Flex>
                </div>
                <Box
                  style={{
                    flex: 1,
                    textAlign: "center",
                    color: theme === "dark" ? "#fff" : "#222",
                    fontWeight: window.innerWidth < 768 ? 400 : 600,
                    fontSize: window.innerWidth < 768 ? 16 : 26,
                    letterSpacing: 0.5,
                  }}
                >
                  <Text weight="regular" className="gil-bold text-xl">
                    <span className="gil-bold text-xl">AI Interview </span>
                    <span className="gil-bold hidden md:inline lg:inline text-xl">
                      On{" "}
                    </span>
                    <span className="gil-bold hidden md:inline lg:inline text-xl">
                      {`${
                        technology && technology !== ""
                          ? technology
                          : "HR Interview"
                      }`}
                    </span>
                  </Text>
                </Box>
                {!InterviewStore.isInterviewCompleted &&
                window.innerWidth > 768 &&
                InterviewStore.chatHistory?.length > 2 ? (
                  <Flex direction="row" align="center" justify="end" pr="4">
                    <Button
                      variant="ghost"
                      size="2"
                      onClick={manualInterviewCompleted}
                      style={{
                        color: "#dc2626",
                        border: "1px solid rgba(220, 38, 38, 0.4)",
                        borderRadius: "6px",
                        padding: "8px 16px",
                        background: "transparent",
                        opacity: 0.8,
                        transition: "none",
                      }}
                    >
                      <Flex align="center" gap="3">
                        <BiExit size={18} />
                        <Text weight="regular">Exit Interview</Text>
                      </Flex>
                    </Button>
                  </Flex>
                ) : null}
                <div
                  className="pr-4"
                  style={{
                    display: window.innerWidth < 768 ? "none" : "block",
                  }}
                >
                  {RecordingSection(
                    InterviewStore.isInterviewStarted,
                    InterviewStore.isInterviewCompleted,
                    InterviewStore.recordPermission,
                  )}
                </div>

                {/* <IconButton
                  id="help-tour-btn"
                  variant="ghost"
                  color="gray"
                  style={{ marginRight: 8 }}
                  onClick={() => {
                    setTourRun(true);
                    setShowTour(true);
                    setTourStepIndex(0);
                  }}
                  aria-label="Show Product Tour"
                >
                  <AiOutlineQuestion size={24} />
                </IconButton> */}
                <Button
                  id="issue-btn"
                  variant="ghost"
                  color="gray"
                  style={{
                    marginRight: 8,
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                  onClick={() => {
                    PopupStore.setIssueReportPopup(true);
                  }}
                  aria-label="Report Issue"
                  size="2"
                  className="gil-med cursor-pointer"
                >
                  <AiOutlineBug
                    size={24}
                    style={{ marginRight: 6 }}
                    className="block md:hidden lg:hidden"
                  />
                  <Text className="hidden md:block lg:block">
                    Facing an issue?
                  </Text>
                </Button>
                <IconButton
                  variant="ghost"
                  color="gray"
                  style={{ marginRight: 24 }}
                  onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
                  aria-label="Toggle theme"
                  id="theme-btn"
                >
                  {theme === "dark" ? (
                    <MdOutlineLightMode size={24} />
                  ) : (
                    <MdOutlineDarkMode size={24} />
                  )}
                </IconButton>
              </Flex>
              {/* Main content */}
              <Flex
                direction="row"
                justify="between"
                align="center"
                gap="4"
                style={{
                  flex: 1,
                  width: "100vw",
                  background: theme === "dark" ? "#18181b" : "white",
                  justifyContent: "space-evenly",
                  alignItems: window.innerWidth < 768 ? "start" : "center",
                }}
              >
                {/* Left: Video/Interview Card */}
                <VideoCallSection
                  technology={technology}
                  setTechnology1={setTechnology1}
                  companyurl={companyurl}
                  name={name}
                  setName2={setName2}
                  levelOfInterview={levelOfInterview}
                  noOfQuestions={noOfQuestions}
                  store={InterviewStore}
                  speech={speech}
                  onBack={onBack}
                  toggleMessageTab={() => InterviewStore.toggleScreen(true)}
                  // new voice recognition props
                  interimResult={interimResult}
                  results={results}
                  isRecording={isRecording}
                  startSpeechToText={startSpeechToText}
                  stopSpeechToText={stopSpeechToText}
                  speechError={error}
                  theme={theme}
                  startTour={startTour}
                />

                {/* Right: Chat Panel */}
                <div
                  className="hidden md:block lg:block"
                  style={{
                    width: window.innerWidth < 768 ? "100vw" : "27vw",
                  }}
                >
                  <div id="conversation-panel">
                    <ChatComponent
                      chat={InterviewStore.chatHistory}
                      theme={theme}
                      userPic={InterviewStore.userPic}
                    />
                  </div>
                </div>
              </Flex>
            </Flex>
          </Theme>

          {/* POP-UP SECTION  */}

          {PopupStore.getMoreCredits && (
            <GetMoreCreditsPopUp
              popUpInitialValue={PopupStore.getMoreCredits}
              handlePopup={() => {
                PopupStore.setGetMoreCredits(false);
              }}
              availableCoins={user.coins}
            />
          )}
          {PopupStore.redeemCoupon && (
            <RedeemCoupon
              popUpInitialValue={true}
              handlePopup={() => {
                PopupStore.setRedeemCoupon(false);
              }}
            />
          )}

          {PopupStore.paymentGateway && (
            <PurchaseCredits
              gateWay="phonePe"
              onClose={() => {
                PopupStore.setPaymentGateway(false);
              }}
            />
          )}

          <IssueReportPopup
            open={PopupStore.issueReportPopup}
            onOpenChange={() => {
              PopupStore.setIssueReportPopup(false);
            }}
            theme={theme}
            changeSttService={(module) => {
              InterviewStore.setSttModule(module); // this is the backup voice service
            }}
            changeTtsService={(module) => {
              InterviewStore.setTtsModule(module); // this is the backup tts service
            }}
          />

          {/* --------------- XXX ------------ */}
          <ConfirmationPopup
            open={showLeaveConfirm}
            onOpenChange={setShowLeaveConfirm}
            title="Leave Interview?"
            message="Are you sure you want to leave the interview? Your progress will be lost."
            confirmButton="Leave"
            cancelButton="Cancel"
            onConfirm={() => {
              setShowLeaveConfirm(false);
              InterviewStore.setUserPic("");
              if (leaveCallback) leaveCallback();
            }}
            onCancel={() => setShowLeaveConfirm(false)}
          />
        </div>
      )}
    </Observer>
  );

  // function interviewStatusSection(activeTab) {
  //   return (
  //     <Observer>
  //       {() => (
  //         <div className="w-[30%] h-full bg-slate-200 p-[2vw] rounded-2xl hidden md:block lg:block">
  //           {/* {tabsComponent()} */}
  //           {activeTab === "tab1" ? (
  //             <div className="h-[90%]">
  //               <ChatComponent
  //                 chat={InterviewStore.chatHistory}
  //                 theme={theme}
  //               />
  //             </div>
  //           ) : (
  //             <div className="h-[90%]">
  //               <InterviewDetailsComponent />
  //             </div>
  //           )}
  //         </div>
  //       )}
  //     </Observer>
  //   );
  // }
}
function VideoCallSection({
  technology,
  setTechnology1,
  levelOfInterview,
  name,
  setName2,
  noOfQuestions,
  speech,
  toggleMessageTab,
  interimResult,
  results,
  isRecording,
  startSpeechToText,
  stopSpeechToText,
  speechError,
  theme,
  startTour,
  // onBack,
}) {
  const { InterviewStore, PopupStore } = useStores();
  const navigate = useNavigate();
  const [proxyStarted, setProxyStarted] = useState(false);
  const customSetting = localStorage.getItem("customSettings")
    ? JSON.parse(localStorage.getItem("customSettings"))
    : [];
  const [isHovered, setIsHovered] = useState(false);
  const [isNoiseCancellation, setIsNoiseCancellation] = useState(false);
  const [stopProxyDetection, setStopProxyDetection] = useState(null);
  const [lastTabSwitchTime, setLastTabSwitchTime] = useState(Date.now());
  const [lastScreenshotTime, setLastScreenshotTime] = useState(0);
  // const [showPrecautions, setShowPrecautions] = useState(false);

  // const [userPic, setUserPic] = useState(
  //   JSON.parse(localStorage.getItem("user"))?.pic
  // );
  const [stream, setStream] = useState(null);
  const streamRef = useRef(null);

  // Added to sync ref with state
  useEffect(() => {
    streamRef.current = stream;
  }, [stream]);

  // useEffect(() => {
  //   localStorage.setItem(
  //     "Avatar",
  //     JSON.stringify(InterviewStore.selectedAudio)
  //   );
  // }, []);

  // Browser detection utility
  const getBrowserInfo = () => {
    const userAgent = navigator.userAgent;
    const isFirefox = userAgent.includes("Firefox");
    const isChrome = userAgent.includes("Chrome") && !userAgent.includes("Edg");
    const isSafari =
      userAgent.includes("Safari") && !userAgent.includes("Chrome");
    const isEdge = userAgent.includes("Edg");

    return {
      isFirefox,
      isChrome,
      isSafari,
      isEdge,
      userAgent,
    };
  };

  const browserInfo = getBrowserInfo();

  // Check and log browser capabilities
  const checkBrowserCapabilities = () => {
    const capabilities = {
      mediaRecorder: !!window.MediaRecorder,
      getUserMedia: !!navigator.mediaDevices?.getUserMedia,
      getDisplayMedia: !!navigator.mediaDevices?.getDisplayMedia,
      supportedMimeTypes: [],
    };

    // Check supported MIME types
    const testMimeTypes = [
      "video/webm;codecs=vp9,opus",
      "video/webm;codecs=vp8,opus",
      "video/webm;codecs=vp9",
      "video/webm;codecs=vp8",
      "video/webm",
      "video/mp4;codecs=vp9",
      "video/mp4;codecs=h264",
      "video/mp4",
    ];

    testMimeTypes.forEach((mimeType) => {
      if (MediaRecorder.isTypeSupported(mimeType)) {
        capabilities.supportedMimeTypes.push(mimeType);
      }
    });

    console.log("Browser capabilities:", capabilities);
    return capabilities;
  };

  // Log browser capabilities on component mount
  useEffect(() => {
    checkBrowserCapabilities();
  }, []);

  /* --------------------- text to speech section methods --------------------- */

  // console.log('these are the voices' + speech.value);

  /* ------------------- speech reconization section methods ------------------ */

  /* ---------------- text to speech package speak-tts methods ---------------- */

  const [interviewStarted, setInterviewStarted] = useState(false);
  const [isinterviewStarted, setIsInterviewStarted] = useState(false);
  const [retryStartInterview, setRetryStartInterview] = useState(false);
  const [isInterviewCompleted, setIsInterviewCompleted] = useState(false);
  const [isFeedbackGiven, setIsFeedbackGiven] = useState(false);
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [interviewDetails, setInterviewDetails] = useState(null);
  const [botCC, setBotCC] = useState(null);
  const [showBotcc, setShowBotcc] = useState(null);
  const [OffCameraPopUp, setOffCameraPopUp] = useState(false);

  const [speaking, setSpeaking] = useState(false);

  const [showCountDownTimer, setShowCountDownTimer] = useState(false);

  const [backSpaceTranscription, setBackSpaceTranscription] = useState("");
  const [isResultGenerated, setIsResultGenerated] = useState(false);
  const [tech, setTech] = useState("");
  const [name1, setName1] = useState("");
  const [request, setRequest] = useState(false);
  const continueInterviewId = new URLSearchParams(window.location.search).get(
    "continue",
  );

  const startInterviewId = new URLSearchParams(window.location.search).get(
    "interviewId",
  );

  const from = new URLSearchParams(window.location.search).get("from");
  const environment = new URLSearchParams(window.location.search).get(
    "environment",
  );

  // Use copy-paste restriction hook - active when interview is started and not completed
  useRestrictCopyPaste(interviewStarted && !isInterviewCompleted);

  // Ref for the main textarea to enable auto-scroll
  const mainTextareaRef = useRef(null);

  // alert(from);
  useEffect(() => {
    if (InterviewStore.isInterviewCompleted) {
      setIsInterviewCompleted(InterviewStore.isInterviewCompleted);
    }
  }, [InterviewStore.isInterviewCompleted]);

  // Auto-scroll effect for the main textarea
  useEffect(() => {
    if (mainTextareaRef.current) {
      mainTextareaRef.current.scrollTop = mainTextareaRef.current.scrollHeight;
    }
  }, [InterviewStore.userVoiceInput, InterviewStore.transcript]);

  // Add new useEffect for tab visibility detection
  useEffect(() => {
    let intervalId;

    const captureScreenshot = async () => {
      try {
        // Check if we have an active screen recording stream
        if (
          streamRef.current &&
          streamRef.current.getVideoTracks().length > 0
        ) {
          // Create a canvas to capture from the screen recording stream
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const videoTrack = streamRef.current.getVideoTracks()[0];

          // Create a video element to capture the screen stream
          const video = document.createElement("video");
          video.srcObject = streamRef.current;
          video.muted = true;
          video.playsInline = true;

          // Wait for video to be ready
          await new Promise((resolve, reject) => {
            const timeout = setTimeout(() => {
              reject(new Error("Video loading timeout"));
            }, 5000); // 5 second timeout

            video.onloadedmetadata = () => {
              clearTimeout(timeout);
              canvas.width = video.videoWidth;
              canvas.height = video.videoHeight;
              resolve();
            };

            video.onerror = () => {
              clearTimeout(timeout);
              reject(new Error("Video loading failed"));
            };

            video.play().catch(reject);
          });

          // Capture the current frame from the screen recording
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

          // Convert canvas to blob with better quality
          canvas.toBlob(
            async (blob) => {
              if (blob) {
                try {
                  const fileName = `tab-switch-screenshot-${Date.now()}-${Math.random()
                    .toString(36)
                    .substr(2, 9)}.png`;

                  // Upload screenshot to Azure
                  const response = await uploadFileToAzure(
                    fileName,
                    blob,
                    { action: "recording" },
                    () => {},
                  );

                  if (response?.url) {
                    console.log(
                      "Screen recording screenshot captured and uploaded:",
                      response.url,
                    );

                    // Update proxy detection with screenshot evidence
                    const screenshotData = {
                      anomalyType: "tabChanges",
                      proof: {
                        type: "image",
                        label: "Tab Switch Screenshot (Screen Recording)",
                        description:
                          "Screenshot captured from screen recording when user switched tab at " +
                          new Date().toLocaleTimeString(),
                        url: response.url,
                      },
                    };

                    // Use interviewDetails._id if available, otherwise use continueInterviewId or startInterviewId
                    const interviewId =
                      interviewDetails?._id ||
                      continueInterviewId ||
                      startInterviewId;
                    if (interviewId) {
                      InterviewStore.updateProxyByInterviewId(
                        interviewId,
                        screenshotData,
                      );
                    } else {
                      console.warn(
                        "No interview ID available for screenshot upload",
                      );
                    }
                  }
                } catch (error) {
                  console.error("Error uploading screenshot:", error);

                  // Fallback: Save screenshot data locally if upload fails
                  const fallbackData = {
                    anomalyType: "tabChanges",
                    proof: {
                      type: "image",
                      label: "Tab Switch Screenshot (Upload Failed)",
                      description:
                        "Screenshot captured from screen recording when user switched tab but upload failed",
                    },
                  };

                  const interviewId =
                    interviewDetails?._id ||
                    continueInterviewId ||
                    startInterviewId;
                  if (interviewId) {
                    InterviewStore.updateProxyByInterviewId(
                      interviewId,
                      fallbackData,
                    );
                  }
                }
              }

              // Clean up video element
              try {
                video.pause();
                video.srcObject = null;
                video.remove();
              } catch (cleanupError) {
                console.warn("Error during video cleanup:", cleanupError);
              }
            },
            "image/png",
            0.9,
          ); // Higher quality PNG
        } else {
          // Fallback to capturing the current page if no screen recording is available
          console.log(
            "No screen recording stream available, falling back to page capture",
          );

          const canvas = await html2canvas(document.body, {
            allowTaint: true,
            useCORS: true,
            scale: 1,
            logging: false,
            width: window.innerWidth,
            height: window.innerHeight,
            backgroundColor: "#ffffff", // Ensure white background
          });

          // Convert canvas to blob with better quality
          canvas.toBlob(
            async (blob) => {
              if (blob) {
                try {
                  const fileName = `tab-switch-screenshot-fallback-${Date.now()}-${Math.random()
                    .toString(36)
                    .substr(2, 9)}.png`;

                  // Upload screenshot to Azure
                  const response = await uploadFileToAzure(
                    fileName,
                    blob,
                    { action: "recording" },
                    () => {},
                  );

                  if (response?.url) {
                    console.log(
                      "Fallback screenshot captured and uploaded:",
                      response.url,
                    );

                    // Update proxy detection with screenshot evidence
                    const screenshotData = {
                      anomalyType: "tabChanges",
                      proof: {
                        type: "image",
                        label: "Tab Switch Screenshot (Fallback)",
                        description:
                          "Screenshot captured from current page when user switched tab (screen recording not available)",
                        url: response.url,
                      },
                    };

                    // Use interviewDetails._id if available, otherwise use continueInterviewId or startInterviewId
                    const interviewId =
                      interviewDetails?._id ||
                      continueInterviewId ||
                      startInterviewId;
                    if (interviewId) {
                      InterviewStore.updateProxyByInterviewId(
                        interviewId,
                        screenshotData,
                      );
                    } else {
                      console.warn(
                        "No interview ID available for screenshot upload",
                      );
                    }
                  }
                } catch (error) {
                  console.error("Error uploading fallback screenshot:", error);

                  // Fallback: Save screenshot data locally if upload fails
                  const fallbackData = {
                    anomalyType: "tabChanges",
                    proof: {
                      type: "image",
                      label: "Tab Switch Screenshot (Fallback Upload Failed)",
                      description:
                        "Fallback screenshot captured when user switched tab but upload failed",
                    },
                  };

                  const interviewId =
                    interviewDetails?._id ||
                    continueInterviewId ||
                    startInterviewId;
                  if (interviewId) {
                    InterviewStore.updateProxyByInterviewId(
                      interviewId,
                      fallbackData,
                    );
                  }
                }
              }
            },
            "image/png",
            0.9,
          ); // Higher quality PNG
        }
      } catch (error) {
        console.error("Error capturing screenshot:", error);

        // Fallback: Record the error in proxy detection
        const errorData = {
          anomalyType: "tabChanges",
          proof: {
            type: "error",
            label: "Screenshot Capture Failed",
            description: "Failed to capture screenshot when user switched tab",
          },
        };

        const interviewId =
          interviewDetails?._id || continueInterviewId || startInterviewId;
        if (interviewId) {
          InterviewStore.updateProxyByInterviewId(interviewId, errorData);
        }
      }
    };

    const handleVisibilityChange = () => {
      const currentTime = Date.now();
      const timeSinceLastSwitch = currentTime - lastTabSwitchTime;

      if (document.hidden) {
        console.log("User switched tab or minimized the window.");
        setLastTabSwitchTime(currentTime);

        // Capture screenshot when user switches tab
        if (interviewStarted && !isInterviewCompleted) {
          const currentTime = Date.now();
          const timeSinceLastScreenshot = currentTime - lastScreenshotTime;

          // Only capture screenshot if at least 2 seconds have passed since last screenshot
          if (timeSinceLastScreenshot > 2000) {
            setLastScreenshotTime(currentTime);
            captureScreenshot();
          } else {
            console.log("Screenshot skipped - too soon since last capture");
          }
        }

        // alert(interviewDetails?._id);

        // If interview is in progress, show a notification
        if (interviewStarted && !isInterviewCompleted) {
        }
      } else {
        console.log("User returned to the tab.");
        setLastTabSwitchTime(currentTime);
      }
    };

    // Set up interval to check tab visibility every 3 seconds
    const setupInterval = () => {
      intervalId = setInterval(() => {
        if (document.hidden && interviewStarted && !isInterviewCompleted) {
          const currentTime = Date.now();
          const timeSinceLastSwitch = currentTime - lastTabSwitchTime;

          if (timeSinceLastSwitch > 3000) {
            console.log(
              `User has been away from the tab for more than 3 seconds (Tab switches: ${InterviewStore.tabSwitchCount})`,
            );
          }
        }
      }, 3000);
    };

    // Initial setup
    document.addEventListener("visibilitychange", handleVisibilityChange);
    setupInterval();

    // Cleanup
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [
    lastTabSwitchTime,
    interviewStarted,
    isInterviewCompleted,
    InterviewStore.tabSwitchCount,
    interviewDetails?._id,
    lastScreenshotTime,
  ]);

  useEffect(() => {
    const getInterviewData = async () => {
      const response = await apiGet(
        `/interview/get-interview-by-id/${startInterviewId}`,
      );
      if (response.status === 200) {
        console.log(response.body, "Interview Data");
        let interviewDetails = {
          name: response.body.data.interviewee?.name,
          technology: response.body.data?.technology,
          levelOfInterview: response.body.data?.levelOfInterview,
          noOfQuestions: response.body.data?.noOfQuestions,
          role: response.body.data.interviewee?.role?._id,
          customQuestions: response.body.data.customSettings,
          whoPay: response.body.data.whoPay,
          resume: response.body.data?.resume,
        };
        setTechnology1(response.body.data?.technology);
        setName2(response.body.data.interviewee?.name);
        InterviewStore.setUserPic(response.body.data.interviewee?.pic);
        if (
          response.body.data.customSettings &&
          response.body.data.customSettings.length > 0
        ) {
          const customSettings = response.body.data.customSettings.map(
            (setting) => {
              if (setting.name === "aiVoice") {
                InterviewStore.setSelectedAudio(setting.value);
              }
            },
          );
        }

        localStorage.setItem(
          "Avatar",
          JSON.stringify(InterviewStore.selectedAudio),
        );
        localStorage.setItem(
          "customSettings",
          JSON.stringify(response.body.data.customSettings),
        );
        InterviewStore.updateInterviewDetails(interviewDetails);

        if (response.body.data.isInterviewCompleted) {
          if (response.body.data?.isResultPublished) {
            if (from === "user-reaidy") {
              if (environment === "production") {
                window.location.href = `https://user.reaidy.io/dashboard/interview-report/${startInterviewId}`;
              } else {
                window.location.href = `https://qa-user.reaidy.io/dashboard/interview-report/${startInterviewId}?environment=${environment}`;
              }
            } else {
              navigateToReportScreen(startInterviewId);
            }
          } else {
            alert("Interview completed. Click 'OK' to generate the result.");

            PopupStore.setTestMedia(false);
            InterviewStore.setIsInterviewCompleted(true);
            setIsInterviewCompleted(true);
          }
        } else if (response.body.data?.questions.length > 0) {
          navigate(
            `/interview/?continue=${startInterviewId}&from=user-reaidy&environment=${environment}`,
          );
        }
      }
    };

    getInterviewData();
  }, [startInterviewId]);

  useEffect(() => {
    const getInterviewData = async () => {
      const response = await apiGet(
        `/interview/get-interview-by-id/${continueInterviewId}`,
      );
      if (response.status === 200) {
        console.log(response.body, "Interview Data");
        let interviewDetails = {
          name: response.body.data.interviewee?.name,
          technology: response.body.data?.technology,
          levelOfInterview: response.body.data?.levelOfInterview,
          noOfQuestions: response.body.data?.noOfQuestions,
          role: response.body.data.interviewee?.role?._id,
          customQuestions: response.body.data.customSettings,
          whoPay: response.body.data.whoPay,
          resume: response.body.data?.resume,
        };
        setTechnology1(response.body.data?.technology);
        setName2(response.body.data.interviewee?.name);
        InterviewStore.setUserPic(response.body.data.interviewee?.pic);
        localStorage.setItem(
          "Avatar",
          JSON.stringify(InterviewStore.selectedAudio),
        );
        localStorage.setItem(
          "customSettings",
          JSON.stringify(response.body.data.customSettings),
        );
        InterviewStore.updateInterviewDetails(interviewDetails);

        if (response.body.data.isInterviewCompleted) {
          if (response.body.data?.isResultPublished) {
            if (from === "user-reaidy") {
              if (environment === "production") {
                window.location.href = `https://user.reaidy.io/dashboard/interview-report/${continueInterviewId}`;
              } else {
                window.location.href = `https://qa-user.reaidy.io/dashboard/interview-report/${continueInterviewId}?environment=${environment}`;
              }
            } else {
              navigateToReportScreen(continueInterviewId);
            }
          } else {
            alert("Interview completed. Click 'OK' to generate the result.");

            PopupStore.setTestMedia(false);
            InterviewStore.setIsInterviewCompleted(true);
            setIsInterviewCompleted(true);
          }
        }
      }
    };

    getInterviewData();
  }, [continueInterviewId]);

  const speak = ({ text }) => {
    /* ----------------------- AZURE SPEECH TO TEXT LOGIC ----------------------- */
    InterviewStore.setbotCC(text);
    const count = text?.length;

    const enableBackupAzureSpeechKey =
      process.env.REACT_APP_ENABLE_BACKUP_AZURE_SPEECH_KEY;
    // alert(enableBackupAzureSpeechKey);
    const voiceId = JSON.parse(localStorage.getItem("customSettings"))?.find(
      (setting) => setting.name === "aiVoice",
    )?.value;
    if (voiceId) {
      const voice = audioOptions.find((option) => option.id === voiceId)?.voice;
      InterviewStore.voiceSlang = voice;
    } else {
      InterviewStore.voiceSlang = JSON.parse(
        localStorage.getItem("Avatar"),
      )?.voice;
    }

    const speechKey =
      enableBackupAzureSpeechKey === "true"
        ? process.env.REACT_APP_BACKUP_AZURE_SPEECH_KEY
        : process.env.REACT_APP_AZURE_SPEECH_KEY;
    // alert(speechKey, process.env.REACT_APP_ENABLE_BACKUP_AZURE_SPEECH_KEY);

    const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
      speechKey,
      process.env.REACT_APP_SPEECH_REGION ?? "centralindia",
    );
    console.log("this is the region", process.env.REACT_APP_SPEECH_REGION);
    const newSynthesizer = new SpeechSDK.SpeechSynthesizer(speechConfig);

    // Adjust the speech speed using prosody rate
    const ssmlText = `
      <speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" xml:lang="en-US">
        <voice name="${InterviewStore.voiceSlang}">
          <prosody rate="${-5.0}">
            ${text}
          </prosody>
        </voice>
      </speak>
    `;

    const speakSsmlAsyncPromise = (ssmlText) => {
      return new Promise((resolve, reject) => {
        newSynthesizer.speakSsmlAsync(
          ssmlText,
          (result) => {
            if (
              result.reason ===
              SpeechSDK.ResultReason.SynthesizingAudioCompleted
            ) {
              resolve(result);
            } else if (result.reason === SpeechSDK.ResultReason.Canceled) {
              reject(new Error(result.errorDetails));
            }
            newSynthesizer.close();
          },
          (err) => {
            reject(err);
            newSynthesizer.close();
          },
        );
      });
    };
    setSpeaking(true);

    speakSsmlAsyncPromise(ssmlText)
      .then((result) => {
        console.log("Speech synthesized to speaker for text [" + text + "]");
        setTimeout(
          () => {
            setSpeaking(false);
            // alert("speech ended");
            if (
              !InterviewStore.isInterviewCompleted &&
              text !== "Please say something"
            ) {
              InterviewStore.setNotificationText(
                `${
                  text === "Please say something"
                    ? "Please say something"
                    : "You can start speaking now"
                }`,
              );
              InterviewStore.setNotificationIcon(<FaHeadSideCough />);

              InterviewStore.setShowNotification(true);
            }
            InterviewStore.setSpeechResult([]);
          },
          count * 100 * 0.58 + 1000,
        );
      })
      .catch((err) => {
        console.log("CANCELED: Reason=" + err.message);
        setSpeaking(false);

        InterviewStore.setSpeechResult([]);
      });
  };

  const speak2 = ({ text }) => {
    InterviewStore.setbotCC(text);
    speech
      .speak({
        text: text,
        queue: false,
        listeners: {
          onstart: () => {
            console.log("Speak started");
            setSpeaking(true);
            // console.log('these are the voices' + text);
          },
          onend: () => {
            console.log("Speak ended");
            InterviewStore.setSpeechResult([]); // reset the speech result
          },
          // onresume: () => {
          //   console.log("Resume utterance");
          // },
          // onboundary: (event) => {
          //   console.log(
          //     event.name +
          //       " boundary reached after " +
          //       event.elapsedTime +
          //       " milliseconds."
          //   );
          // },
        },
      })
      .then(() => {
        console.log("Success !");
        console.log("End of speech");
        if (
          !InterviewStore.isInterviewCompleted &&
          text !== "Please say something"
        ) {
          InterviewStore.setNotificationText(
            `${
              text === "Please say something"
                ? "Please say something"
                : "You can start speaking now"
            }`,
          );
          InterviewStore.setNotificationIcon(<FaHeadSideCough />);
          InterviewStore.setShowNotification(true);
        }

        setSpeaking(false);
      })
      .catch((e) => {
        console.error("An error occurred :", e);
      });
  };

  useEffect(() => {
    if (!interviewStarted) return;

    InterviewStore.setSpeaking(speaking);
    console.log(speaking);

    /* ----------------------- AZURE SPEECH TO TEXT LOGIC ----------------------- */

    if (speaking && InterviewStore.sttModule === "azure-stt") {
      toggleMuted(false);
    } else if (!speaking && InterviewStore.sttModule === "azure-stt") {
      toggleMuted(true);
      InterviewStore.clearTranscriptAndUserVoiceInput();
    }

    /* ----------------------- END OF AZURE SPEECH TO TEXT LOGIC ----------------------- */

    if (speaking) {
      if (mobileView) {
        // stopSpeechToText();
        toggleDomMic(false);
      }
      // SpeechRecognition.stopListening();
    } else {
      setTimeout(() => {
        setBotCC(null);
      }, 3000);

      resetTranscript();
      if (mobileView) {
        InterviewStore.setLastSubmitTimeStamp(); // this is for mobile view speech to text
        // startSpeechToText();
        toggleDomMic(true);
      }
      // InterviewStore.resetTranscript();
      // SpeechRecognition.startListening({
      //   language: "en-IN",
      //   continuous: true,
      // });
    }
  }, [speaking]);

  useEffect(() => {
    if (botCC) {
      setTimeout(() => {
        setShowBotcc(true);
      }, 500);
    } else {
      setShowBotcc(false);
    }
  }, [botCC]);

  const askQuestionToUser = ({ text }) => {
    // SpeechRecognition.stopListening();
    let filteredText = removeLucy(text); // remove "Lucy:" from the text
    setBotCC(filteredText);
    process.env.REACT_APP_AZURE_VOICE === "true" &&
    InterviewStore.ttsModule === "azure-tts"
      ? speak({
          text: filteredText,
        })
      : speak2({
          text: filteredText,
        });
  };

  const pushMessagesToChat = (messageObject) => {
    console.log("msg object", messageObject);
    InterviewStore.setChatHistory([
      ...InterviewStore.chatHistory,
      ...messageObject,
    ]);
  };

  const toggleLoader = (state) => {
    InterviewStore.setLoading(state);
  };
  const checkInterviewCompleted = (paragraph) => {
    return interviewCompletedSequence.some((sequence) =>
      paragraph.includes(sequence),
    );
  };

  const goFullScreen = async () => {
    const element = document.documentElement;

    try {
      if (element.requestFullscreen) {
        await element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        await element.webkitRequestFullscreen();
      } else if (element.mozRequestFullScreen) {
        await element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        await element.msRequestFullscreen();
      }
    } catch (fullscreenError) {
      console.warn("Fullscreen request failed:", fullscreenError);
      // Continue with interview even if fullscreen fails
    }
  };

  const continueTheInterview = async () => {
    InterviewStore.setUserMSGError(false);
    let transcription = InterviewStore.userVoiceInput
      ? InterviewStore.userVoiceInput + " " + InterviewStore.transcript
      : InterviewStore.transcript;
    // let transcription = InterviewStore.userVoiceInput;
    if (transcription.trim() === "") {
      return askQuestionToUser({ text: "Please say something" });
    }
    // SpeechRecognition.stopListening(); // stop listening to the user
    const body = {
      interviewId: InterviewStore.presentInterviewDetails._id,
      userResponse: transcription,
    };
    pushMessagesToChat([{ role: "user", content: transcription }]); // some times the user response is not getting pushed to the chat
    toggleLoader(true);

    /* --------------- now call the api to continue the interview --------------- */
    try {
      let newBody = body;
      console.log(body);
      newBody = {
        ...newBody,
        cluster: getclusterbyDomain(),
      };

      const res = await apiPostPut(
        newBody,
        "/interview/continue-interview",
        "POST",
      );

      console.log(res);
      toggleLoader(false);
      if (res.status === 200) {
        if (res?.body?.success) {
          askQuestionToUser({ text: res?.body?.data?.body?.content });
          pushMessagesToChat([res?.body?.data?.body]);
          if (res?.body?.data?.interviewDone === true) {
            setTimeout(() => {
              InterviewStore.setCameraNotification(false);
              InterviewStore.setNotificationText(
                "Interview Completed Successfully",
              );
              InterviewStore.setNotificationIcon(
                <RiRecordCircleLine className="text-[#FA3532] text-xl" />,
              );
              InterviewStore.setShowNotification(true);
              setIsInterviewCompleted(true);
              InterviewStore.setIsInterviewCompleted(true);
            }, 4000);
          } else if (checkInterviewCompleted(res?.body?.data?.body?.content)) {
            // check if the interview is completed or not
            // alert("Interview Completed Successfully");
            InterviewStore.setNotificationText(
              "Interview Completed Successfully",
            );
            InterviewStore.setNotificationIcon(
              <IoCheckmarkCircleOutline className="text-green-600 text-xl" />,
            );
            InterviewStore.setShowNotification(true);
            InterviewStore.setIsInterviewCompleted(true);
            setTimeout(() => {
              InterviewStore.setIsInterviewCompleted(true);
              setIsInterviewCompleted(true);
            }, 3000);
          }
        } else alert("something went wrong, Please submit your response again");

        return;
      }

      // alert(
      //   `Something went wrong. Please try again later. error:${res.status}`
      // );
      InterviewStore.setUserMSGError(true);
      // })
      // catch((err) => {
      //   toggleLoader(false);
      //   console.log(err);

      //   alert(`something went wrong ${err}`);

      //   // alert("Something went wrong. Please try again later. error: 29");
      // });
    } catch (error) {
      toggleLoader(false);
      console.log(error);
    } finally {
      resetTranscript();
      InterviewStore.setLastSubmitTimeStamp(); // this is for mobile view speech to text
      // InterviewStore.resetTranscript();
      // setBackSpaceTranscription("");
      InterviewStore.resetUserVoiceInput();
    }
  };

  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [recordedChunks, setRecordedChunks] = useState([]);
  const [recordPermissionByUser, setRecordPermissionByUser] = useState(false);

  const isUserSignup = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      if (user?._id) {
        return true;
      }
      alert("Please logout and signup again");
      return false;
    }
    return false;
  };

  const askUserAboutRecording = () => {
    if (!isUserSignup()) {
      // alert("Please signup to start interview");
      // if (window.confirm("Would you like to signup now?")) {
      //   // open the signup page in new tab
      //   alert("Please complete the signup process & come back to this page.");
      //   // instead of https://app.reaidy.io get the current url
      //   const currentUrl = window.location.origin;
      //   const signupUrl = `${currentUrl}/signup`;
      //   console.log(signupUrl);
      //   return window.open(signupUrl, "_blank");
      // }

      // return;

      // if (!startInterviewId && !continueInterviewId) {
      //   return PopupStore.setLoginWarning(true);
      // }

      if (from === "user-reaidy") {
        PopupStore.setLoginWarning(false);
      } else {
        return PopupStore.setLoginWarning(true);
      }
    }
    if (!isMobileView) {
      try {
        if (customSetting[2]?.value || customSetting[7]?.value) {
          // if (
          //   window.confirm("Would you like to record your interview session")
          // ) {
          //   // PopupStore.setRequestPermissionPopUp(true);
          //   // console.log(PopupStore.requestPermissionPopUp, "record");
          //   startRecording(); // added the start recording method and interview initiation method
          //   setRecordPermissionByUser(true);
          // } else {
          //   setRecordPermissionByUser(false);
          //   initiateInterview(); // initiate the interview
          // }
          // alert("Your interview will be recorded");
          // PopupStore.setRequestPermissionPopUp(true);
          startRecording();
        } else {
          // startRecording(); // added the start recording method and interview initiation method
          // setRecordPermissionByUser(true);
          initiateInterview(); // initiate the interview
          goFullScreen();
        }
      } catch (error) {
        // if (window.confirm("Would you like to record your interview session")) {
        //   PopupStore.setRequestPermissionPopUp(true);
        //   console.log(PopupStore.requestPermissionPopUp, "record");
        //   // startRecording(); // added the start recording method and interview initiation method
        //   // setRecordPermissionByUser(true);
        // } else {
        //   setRecordPermissionByUser(false);
        //   initiateInterview(); // initiate the interview
        // }
        initiateInterview(); // initiate the interview
        goFullScreen();
      }
    } else {
      console.log(" mobile view");
      InterviewStore.setRecordPermission(false);
      setRecordPermissionByUser(false);
      initiateInterview(); // initiate the interview
    }
  };

  async function combineStreams(audioStream, screenStream) {
    const audioContext = new AudioContext();
    const destination = audioContext.createMediaStreamDestination();

    // Create source nodes for both audio streams
    const audioSource = audioContext.createMediaStreamSource(audioStream);
    const screenAudioSource =
      audioContext.createMediaStreamSource(screenStream);

    // Adjust the volume (gain) if necessary, to avoid clipping
    const gainNode = audioContext.createGain();
    gainNode.gain.value = 1.0; // Adjust the value if needed

    // Connect both sources to the gain node, then to the destination
    audioSource.connect(gainNode).connect(destination);
    screenAudioSource.connect(gainNode).connect(destination);

    // Create a new MediaStream for the combined output
    const combinedStream = new MediaStream();

    // Add the combined audio track to the stream
    destination.stream
      .getAudioTracks()
      .forEach((track) => combinedStream.addTrack(track));

    // Add the video track from the screen stream
    screenStream
      .getVideoTracks()
      .forEach((track) => combinedStream.addTrack(track));

    return combinedStream;
  }

  const mixAudioStreams = (audioStream1, audioStream2) => {
    const audioContext = new (
      window.AudioContext || window.webkitAudioContext
    )();
    const destination = audioContext.createMediaStreamDestination();

    // Check if streams have audio tracks before creating sources
    const hasAudio1 = audioStream1 && audioStream1.getAudioTracks().length > 0;
    const hasAudio2 = audioStream2 && audioStream2.getAudioTracks().length > 0;

    console.log(
      "Audio mixing - Stream 1 has audio:",
      hasAudio1,
      "Stream 2 has audio:",
      hasAudio2,
    );

    if (hasAudio1) {
      const source1 = audioContext.createMediaStreamSource(audioStream1);
      source1.connect(destination);
    }

    if (hasAudio2) {
      const source2 = audioContext.createMediaStreamSource(audioStream2);
      source2.connect(destination);
    }

    // If neither stream has audio, return the first stream (should be the microphone)
    if (!hasAudio1 && !hasAudio2) {
      console.warn(
        "No audio tracks found in either stream, returning microphone stream",
      );
      return audioStream1;
    }

    return destination.stream;
  };

  async function compressBlob(blob) {
    const arrayBuffer = await blob.arrayBuffer();
    const compressed = Pako.deflate(new Uint8Array(arrayBuffer), { level: 9 });
    // const compressed = brotli.compress(new Uint8Array(arrayBuffer), { quality: 11 });
    return new Blob([compressed], { type: blob.type });
  }
  // async function downloadBlob1(blob, filename) {
  //   // Compress the Blob before downloading
  //   const compressedBlob = await compressBlob(blob);

  //   // Create a URL for the compressed Blob
  //   const url = window.URL.createObjectURL(compressedBlob);
  //   const a = document.createElement("a");
  //   a.style.display = "none";
  //   a.href = url;
  //   a.download = filename;
  //   document.body.appendChild(a);
  //   a.click();
  //   window.URL.revokeObjectURL(url);
  // }

  //   function downloadBlob(blob, filename) {
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.style.display = "none";
  //     a.href = url;
  //     a.download = filename;
  //     document.body.appendChild(a);
  //     a.click();
  //     window.URL.revokeObjectURL(url);
  // }

  // Safari detection utility
  function isSafariBrowser() {
    const ua = navigator.userAgent;
    return (
      ua.includes("Safari") &&
      !ua.includes("Chrome") &&
      !ua.includes("Chromium") &&
      !ua.includes("Android") &&
      !ua.includes("CriOS")
    );
  }

  const startRecording = async (aud = true) => {
    let isRecordingStopped = false;
    if (!window.MediaRecorder) {
      alert(
        "MediaRecorder API is not supported in this browser. Please use a modern browser like Chrome, Firefox, or Edge.",
      );
      return;
    }
    try {
      // Safari: use minimal constraints
      const audioConstraints = isSafariBrowser()
        ? true
        : {
            noiseSuppression: InterviewStore.noiseCancellation,
            echoCancellation: InterviewStore.noiseCancellation,
            autoGainControl: false,
          };
      const audioStream = await navigator.mediaDevices.getUserMedia({
        audio: audioConstraints,
      });
      // Safari: use minimal constraints for screen
      const screenConstraints = isSafariBrowser()
        ? { video: true, audio: aud }
        : {
            video: {
              width: { max: 1280 },
              height: { max: 720 },
              frameRate: { max: 15 },
            },
            audio: aud,
          };
      const screenStream =
        await navigator.mediaDevices.getDisplayMedia(screenConstraints);
      await setupRecording(audioStream, screenStream, aud);
      goFullScreen();
    } catch (error) {
      console.error("Error accessing media devices:", error);
      InterviewStore.setLoading(false);
      setInterviewStarted(false);
      InterviewStore.setIsInterviewStarted(false);
      if (isSafariBrowser() && error.name === "NotAllowedError") {
        alert(
          "Safari requires you to allow camera/microphone access. Please check your browser settings and ensure you have granted permissions. If you previously denied, go to Safari > Settings > Websites > Camera/Microphone and allow access for this site.",
        );
      } else if (error.name === "NotAllowedError") {
        if (error.message && error.message.includes("microphone")) {
          alert(
            "Microphone permission was denied. Please allow microphone access to continue.",
          );
        } else if (error.message && error.message.includes("display")) {
          alert(
            "Screen recording permission was denied. Please allow screen sharing to continue.",
          );
        } else {
          alert(
            "Media permission was denied. Please allow microphone and screen sharing to continue.",
          );
        }
      } else if (error.name === "NotFoundError") {
        alert(
          "No microphone or camera found. Please check your device and try again.",
        );
      } else if (error.name === "NotReadableError") {
        alert(
          "Your microphone or camera is already in use by another application. Please close other applications and try again.",
        );
      } else {
        alert(
          "Unable to access your media devices. Please check your permissions and try again.",
        );
      }
      console.log("Recording setup failed, not retrying");
    }
  };

  // Separate function to setup recording after getDisplayMedia is called
  const setupRecording = async (audioStream, screenStream, aud) => {
    let isRecordingStopped = false;

    try {
      const videoTrack = screenStream.getVideoTracks()[0];
      setStream(screenStream);

      // Check if the video track is a screen, a window, or a tab
      if (
        videoTrack.label.includes("screen") ||
        videoTrack.label.includes("Primary Monitor")
      ) {
        console.log("User is sharing the entire screen", videoTrack.label);
        videoTrack.addEventListener("ended", () => {
          if (InterviewStore.textRestriction) {
            alert("You are proceeding against the guidelines.");
            stopRecording();
            toggleCamera(false);
            toggleMuted(false);
            InterviewStore.setUserVoiceInput("");
            InterviewStore.setTranscription("");
            InterviewStore.setChatHistory([]);
            askQuestionToUser({ text: "" });
            setInterviewStarted(false);
            navigate(
              `/interview/?continue=${InterviewStore.interviewId}&from=${from}&environment=${environment}`,
            );
            InterviewStore.setIsInterviewStarted(false);
            return InterviewStore.setLoading(false);
          }
        });
        // videoTrack.addEventListener("ended", handleVideoTrackEnded);
        // console.log("Event listener for video track 'ended' event attached.");
      } else if (videoTrack.label.includes("window")) {
        // alert("User is sharing a single window");
        console.log("User is sharing a single window");
        screenStream.getVideoTracks().forEach((track) => track.stop());
        setInterviewStarted(false);
        InterviewStore.setIsInterviewStarted(false);
        PopupStore.setShareScreen(true); // show the popup to share the full screen
        toggleCamera(false);
        return toggleMuted(false);
      } else if (videoTrack.label.includes("tab")) {
        // alert("User is sharing a browser tab");
        console.log("User is sharing a browser tab");
        screenStream.getVideoTracks().forEach((track) => track.stop());
        setInterviewStarted(false);
        InterviewStore.setIsInterviewStarted(false);
        PopupStore.setShareScreen(true); // show the popup to share the full screen
        toggleCamera(false);
        return toggleMuted(false);
      } else {
        // alert("Unable to determine the shared source");
        console.log("Unable to determine the shared source", videoTrack.label);
        screenStream.getVideoTracks().forEach((track) => track.stop());
        setInterviewStarted(false);
        InterviewStore.setIsInterviewStarted(false);
        PopupStore.setShareScreen(true); // show the popup to share the full screen
        toggleCamera(false);
        return toggleMuted(false);
      }
      // setStream(screenStream);
      // Check if the video track is a screen, a window, or a tab
      if (videoTrack.label.includes("screen")) {
        console.log("User is sharing the entire screen");
        videoTrack.addEventListener("ended", () => {
          if (InterviewStore.textRestriction) {
            alert("You are proceeding against the guidelines.");
            stopRecording();
            toggleCamera(false);
            toggleMuted(false);
            InterviewStore.setUserVoiceInput("");
            InterviewStore.setTranscription("");
            InterviewStore.setChatHistory([]);
            askQuestionToUser({ text: "" });
            setInterviewStarted(false);
            navigate(
              `/interview/?continue=${InterviewStore.interviewId}&from=${from}&environment=${environment}`,
            );
            InterviewStore.setIsInterviewStarted(false);
            return InterviewStore.setLoading(false);
          }
        });
        // videoTrack.addEventListener("ended", handleVideoTrackEnded);
        // console.log("Event listener for video track 'ended' event attached.");
      } else if (videoTrack.label.includes("window")) {
        // alert("User is sharing a single window");
        console.log("User is sharing a single window");
        screenStream.getVideoTracks().forEach((track) => track.stop());
        setInterviewStarted(false);
        InterviewStore.setIsInterviewStarted(false);
        PopupStore.setShareScreen(true); // show the popup to share the full screen
        toggleCamera(false);
        return toggleMuted(false);
      } else if (videoTrack.label.includes("tab")) {
        // alert("User is sharing a browser tab");
        console.log("User is sharing a browser tab");
        screenStream.getVideoTracks().forEach((track) => track.stop());
        setInterviewStarted(false);
        InterviewStore.setIsInterviewStarted(false);
        PopupStore.setShareScreen(true); // show the popup to share the full screen
        toggleCamera(false);
        return toggleMuted(false);
      } else {
        // alert("Unable to determine the shared source");
        console.log("Unable to determine the shared source");
        screenStream.getVideoTracks().forEach((track) => track.stop());
        setInterviewStarted(false);
        InterviewStore.setIsInterviewStarted(false);
        PopupStore.setShareScreen(true); // show the popup to share the full screen
        toggleCamera(false);
        return toggleMuted(false);
      }
      // setStream(screenStream);

      // if (videoRef.current) {
      //   videoRef.current.srcObject = screenStream;
      // }
    } catch (error) {
      console.log(error);
      console.error("Error accessing screen:", error);
      InterviewStore.setLoading(false);
      setInterviewStarted(false);
      InterviewStore.setIsInterviewStarted(false);
    }

    // Check if screen stream has audio tracks
    const screenHasAudio =
      screenStream && screenStream.getAudioTracks().length > 0;
    const micHasAudio = audioStream && audioStream.getAudioTracks().length > 0;

    console.log(
      "Audio check - Screen has audio:",
      screenHasAudio,
      "Microphone has audio:",
      micHasAudio,
    );

    let mixedAudio = null;
    if (aud && screenHasAudio && micHasAudio) {
      // Both streams have audio, mix them
      console.log("Mixing audio from both microphone and screen");
      mixedAudio = mixAudioStreams(audioStream, screenStream);
    } else if (micHasAudio) {
      // Only microphone has audio, use it
      console.log("Using microphone audio only");
      mixedAudio = audioStream;
    } else if (screenHasAudio) {
      // Only screen has audio, use it
      console.log("Using screen audio only");
      mixedAudio = screenStream;
    } else {
      // No audio available
      console.warn("No audio tracks available from either source");
      mixedAudio = new MediaStream(); // Empty stream
    }

    const combinedStream = new MediaStream();

    // Add audio tracks if available
    if (mixedAudio && mixedAudio.getAudioTracks().length > 0) {
      mixedAudio
        .getAudioTracks()
        .forEach((track) => combinedStream.addTrack(track));
    }

    // Add video tracks
    if (screenStream && screenStream.getVideoTracks().length > 0) {
      screenStream
        .getVideoTracks()
        .forEach((track) => combinedStream.addTrack(track));
    }

    console.log(
      "Combined stream - Audio tracks:",
      combinedStream.getAudioTracks().length,
      "Video tracks:",
      combinedStream.getVideoTracks().length,
    );

    // Check if we have any tracks to record
    if (combinedStream.getTracks().length === 0) {
      console.error("No tracks available for recording");
      alert(
        "No media tracks available for recording. Please check your permissions and try again.",
      );
      return;
    }

    // Firefox-compatible MIME type detection
    const getSupportedMimeType = () => {
      // Firefox-specific MIME types (Firefox has better support for WebM)
      const firefoxMimeTypes = [
        "video/webm;codecs=vp9,opus",
        "video/webm;codecs=vp8,opus",
        "video/webm;codecs=vp9",
        "video/webm;codecs=vp8",
        "video/webm",
      ];

      // Chrome/Edge-specific MIME types
      const chromeMimeTypes = [
        "video/mp4;codecs=vp9",
        "video/mp4;codecs=h264",
        "video/mp4",
        "video/webm;codecs=vp9,opus",
        "video/webm;codecs=vp8,opus",
        "video/webm;codecs=vp9",
        "video/webm;codecs=vp8",
        "video/webm",
      ];

      // Use Firefox-specific types if Firefox is detected
      const mimeTypes = browserInfo.isFirefox
        ? firefoxMimeTypes
        : chromeMimeTypes;
      for (const mimeType of mimeTypes) {
        if (MediaRecorder.isTypeSupported(mimeType)) {
          console.log(
            `Using MIME type: ${mimeType} for ${
              browserInfo.isFirefox ? "Firefox" : "Chrome/Edge"
            }`,
          );
          return mimeType;
        }
      }

      console.warn("No supported MIME type found, using default");
      return "video/webm";
    };

    const mimeType = getSupportedMimeType();
    const recorderOptions = {
      mimeType,
      videoBitsPerSecond: 850_000, // 700 kbps
      audioBitsPerSecond: 96_000, // 96 kbps
    };

    // For Firefox, we need to handle the case where mimeType might not be supported
    let recorder;
    try {
      recorder = new MediaRecorder(combinedStream, recorderOptions);
      console.log(
        `MediaRecorder created successfully with options:`,
        recorderOptions,
      );
    } catch (error) {
      console.warn(
        "Failed to create MediaRecorder with specified options, trying without options:",
        error,
      );
      try {
        recorder = new MediaRecorder(combinedStream);
        console.log("MediaRecorder created successfully without options");
      } catch (fallbackError) {
        console.error(
          "Failed to create MediaRecorder even without options:",
          fallbackError,
        );
        throw new Error(
          `Unable to create MediaRecorder: ${fallbackError.message}`,
        );
      }
    }

    setMediaRecorder(recorder);

    const chunks = [];
    recorder.ondataavailable = (event) => {
      if (event.data && event.data.size > 0) {
        chunks.push(event.data);
      }
    };

    recorder.onstop = async () => {
      console.log("recording stopped");
      if (!isRecordingStopped && chunks.length > 0) {
        // Determine the correct MIME type for the blob based on what was actually recorded
        let blobType = "video/webm";
        if (mimeType.includes("mp4")) {
          blobType = "video/mp4";
        } else if (mimeType.includes("webm")) {
          blobType = "video/webm";
        }

        const blob = new Blob(chunks, { type: blobType });
        console.log(
          `Recording completed with ${chunks.length} chunks, total size: ${blob.size} bytes`,
        );

        screenRecordBlob = blob;
        setRecordedChunks(chunks);
        downloadRecording(blob); // Download recording after it stops
      } else {
        console.warn(
          "Recording stopped but no data available or recording was intentionally stopped",
        );
      }
    };

    recorder.onerror = (event) => {
      console.error("MediaRecorder error:", event.error);
      alert("Recording error occurred. Please try again.");
    };

    recorder.onstart = () => {
      console.log("recording started");
      console.log(`Recording with MIME type: ${mimeType}`);
      console.log(
        `Browser: ${
          browserInfo.isFirefox
            ? "Firefox"
            : browserInfo.isChrome
              ? "Chrome"
              : browserInfo.isEdge
                ? "Edge"
                : "Other"
        }`,
      );
      initiateInterview(); // initiated the interview here
    };

    // Start recording with error handling
    try {
      recorder.start(1000); // Start recording with 1-second timeslice for better chunk handling
      console.log("Recording started successfully");
    } catch (startError) {
      console.error("Failed to start recording:", startError);
      alert("Failed to start recording. Please try again.");
      return;
    }

    const stopRecording = () => {
      if (recorder && recorder.state !== "inactive") {
        isRecordingStopped = true; // Set flag to true indicating intentional stop
        recorder.stop();
      }
    };
    // const handleVideoTrackEnded = () => {
    //   console.log("Video track ended event triggered");
    //   console.log(
    //     "Current isInterviewCompleted state:",
    //     isInterviewCompleted
    //   );

    //   if (!isInterviewCompleted && InterviewStore.textRestriction) {
    //     alert("You are proceeding against the guidelines.");
    //     stopRecording();
    //     toggleCamera(false);
    //     toggleMuted(false);
    //     InterviewStore.setUserVoiceInput("");
    //     InterviewStore.setTranscription("");
    //     InterviewStore.setChatHistory([]);
    //     askQuestionToUser({ text: "" });
    //     setInterviewStarted(false);
    //     InterviewStore.setLoading(false);
    //   } else {
    //     isRecordingStopped = false;
    //     recorder.stop();
    //     console.log("Recorder stopped because interview is completed.");
    //   }
    // };
  };

  const continueInterview = async () => {
    try {
      const res = await apiGet(
        `/interview/resume-interview/${continueInterviewId}`,
      );
      InterviewStore.setLoading(false);

      if (res.status === 200) {
        if (res?.body?.success) {
          setName1(res?.body?.data?.interviewee?.name);
          setTech(
            res?.body?.data?.technology === ""
              ? "HR"
              : res?.body?.data?.technology,
          );
          InterviewStore.setInterviewId(res?.body?.data?._id);
          setInterviewStarted(true);
          InterviewStore.setIsInterviewStarted(true);
          setInterviewDetails(res?.body?.data);
          InterviewStore.setPresentInterviewDetails(res?.body?.data);
          localStorage.setItem(
            "interviewDetails",
            JSON.stringify(res?.body?.data),
          );

          // Clean up metricsId after successful interview start
          localStorage.removeItem("interviewMetricsId");
          // ✅ Trigger proxy detection only once
          if (
            !proxyStarted &&
            res?.body?.data?._id &&
            (res?.body?.data?.interviewee?._id ||
              typeof res?.body?.data?.interviewee === "string") &&
            res?.body?.data.customSettings?.find(
              (setting) => setting.name === "proxy" && setting.value === true,
            )
          ) {
            console.log(
              "✅ Triggering proxy detection ONCE from interviewSuccess",
            );
            startAdvancedProxyDetection(
              InterviewStore,
              res?.body?.data._id,
              res?.body?.data.interviewee._id ?? res?.body?.data.interviewee,
            );
            setProxyStarted(true);
          } else {
            console.log("Proxy detection is not triggered!!!");
          }
          InterviewStore.setChatHistory(res?.body?.data?.messages);

          const lastMessage =
            res?.body?.data?.messages?.[res.body.data.messages?.length - 1]
              ?.content;
          askQuestionToUser({ text: lastMessage });
          setIsInterviewStarted(true);
          setRetryStartInterview(false);
        } else alert("Unable to start interview");

        return;
      }
    } catch (error) {}
  };
  const initiateInterview = async () => {
    const interviewSuccess = (interviewResponse) => {
      setInterviewStarted(true);
      InterviewStore.setIsInterviewStarted(true);
      console.log("1016", interviewResponse);
      const data = interviewResponse?.result;
      setInterviewDetails(data);
      InterviewStore.setPresentInterviewDetails(data);
      localStorage.setItem("interviewDetails", JSON.stringify(data));

      // ✅ Trigger proxy detection only once
      if (
        !proxyStarted &&
        data?._id &&
        (data?.interviewee?._id || typeof data?.interviewee === "string") &&
        data.customSettings?.find(
          (setting) => setting.name === "proxy" && setting.value === true,
        )
      ) {
        console.log("✅ Triggering proxy detection ONCE from interviewSuccess");
        startAdvancedProxyDetection(
          InterviewStore,
          data._id,
          data.interviewee._id ?? data.interviewee,
        );
        setProxyStarted(true);
      } else {
        console.log("Proxy detection is not triggered!!!");
      }

      const systemPrompt = interviewResponse?.interviewResponse?.systemQuestion;
      const introductionMessage = interviewResponse?.interviewResponse?.body;
      let chatHistory = [systemPrompt, introductionMessage];
      InterviewStore.setChatHistory(chatHistory);
      askQuestionToUser({ text: introductionMessage?.content });
      setRetryStartInterview(false);
    };

    //

    try {
      const userDetails = JSON.parse(localStorage.getItem("user"));
      // Step 1: Access the current URL's query string
      const queryString = window.location.search;

      // Step 2: Use URLSearchParams to parse the query string
      const urlParams = new URLSearchParams(queryString);

      // Step 3: Extract the applicationId
      const applicationId = urlParams.get("applicationId");

      // Now you can use applicationId as needed

      // Get metricsId from localStorage if available
      const metricsId = localStorage.getItem("interviewMetricsId");

      let body = {
        interviewee: userDetails?._id,
        name: name,
        technology: technology,
        levelOfInterview: levelOfInterview,
        noOfQuestions: noOfQuestions,
        applicationId: applicationId,
        ...(metricsId && { metricsId: metricsId }), // Include metricsId if available
      };

      let interviewSettings = JSON.parse(
        localStorage.getItem("interviewSettings"),
      );

      // change id as interviewId in interviewsettings and remove id field from interviewsettings
      interviewSettings = {
        ...interviewSettings,
        interviewId: interviewSettings?.id ?? interviewSettings?.interviewId,
      };

      delete interviewSettings?.id;

      body = { ...body, ...interviewSettings };

      console.log(body);
      // setLoading(true);
      InterviewStore.setLoading(true);
      // console.log("this is interviewSettings", interviewSettings);
      let newBody = body;
      const carrer = JSON.parse(localStorage.getItem("career"));
      console.log(carrer);
      const voice = JSON.parse(localStorage.getItem("customSettings"))?.find(
        (setting) => setting.name === "aiVoice",
      )?.value;

      if (voice) {
        const name = audioOptions.find((option) => option.id === voice)?.label;
        if (name) {
          newBody = {
            ...newBody,
            botName: name,
          };
        }
      } else {
        const name = JSON.parse(localStorage.getItem("Avatar"))?.label;
        if (name) {
          newBody = {
            ...newBody,
            botName: name,
          };
        }
      }
      newBody = {
        ...newBody,
        cluster: getclusterbyDomain(),
      };
      if (carrer) {
        newBody = {
          ...newBody,
          interviewType: "real",

          ...carrer,
        };
      }
      console.log(newBody);

      if (continueInterviewId) {
        // alert("Interview is already started");
        continueInterview();
        goFullScreen();
        return;
      }
      console.log(newBody);

      const apiEndPoint = startInterviewId
        ? `/interview/start-interview`
        : `/interview/new-interview?model=${interviewSettings?.model}&id=${interviewSettings?.id}`;

      if (startInterviewId) {
        newBody = { interviewId: startInterviewId };
      }

      const res = await apiPostPut(newBody, apiEndPoint, "POST");
      // axios
      // .post(
      //   `${apiLink}/interview/new-interview?model=${interviewSettings?.model}&id=${interviewSettings?.id}`,
      //   newBody
      // )
      // .then((res) => {
      console.log(res);

      await InterviewStore.newProxy(
        res?.body?.data?.result?._id,
        res?.body?.data?.result?.interviewee,
      );

      InterviewStore.setInterviewId(res?.body?.data?.result?._id); // ✅ Save ID for later
      InterviewStore.interviewee = res?.body?.data?.result?.interviewee;
      InterviewStore.setLoading(false);
      if (res.status === 200) {
        // Clean up metricsId after successful interview initiation
        localStorage.removeItem("interviewMetricsId");

        if (
          res?.body?.data?.result?.interviewType === "real" &&
          res?.body?.data?.result?.customSettings?.find(
            (setting) => setting.name === "mobile" && setting.value !== true,
          )
        ) {
          if (window.innerWidth < 999) {
            alert(
              "Please attempt the interview on a laptop or desktop computer. Mobile devices are not allowed for this interview.",
            );
            if (from === "user-reaidy") {
              if (environment === "production") {
                return (window.location.href = `https://user.reaidy.io`);
              } else {
                return (window.location.href = `https://user.staging.reaidy.io`);
              }
            }
            return navigate("/dashboard/dashboard");
          }
          const typing = JSON.parse(
            localStorage.getItem("customSettings"),
          )?.find((setting) => setting.name === "typing")?.value;
          if (typing) {
            InterviewStore.setTextRestriction(false);
          } else {
            InterviewStore.setTextRestriction(true);
          }
        }
        console.log(res?.body);
        setIsInterviewStarted(true);
        if (res?.body?.success) interviewSuccess(res?.body?.data);
        else alert("Unable to start interview");

        return;
      }
      alert(
        res?.body?.message ??
          "Something went wrong. Please try again later. error: 25",
      );
      toggleCamera(false);
      toggleMuted(false);
      setInterviewStarted(false);
      InterviewStore.setIsInterviewStarted(false);
      if (
        res?.body?.message.includes(
          "Your Recruiter don't have enough credits(0) to start the interview",
        )
      ) {
        navigate("/dashboard/dashboard");
      }

      // check res?.data?.message contains "You don't have enough credits"
      if (res?.body?.message.includes("You don't have enough credits")) {
        PopupStore.setGetMoreCredits(true);
      }

      // alert("Something went wrong. Please try again later. error: 25");
      // })
      // .catch((err) => {
      //   console.log(err);

      //   InterviewStore.setLoading(false);
      //   setRetryStartInterview(true);
      //   setInterviewStarted(false);
      //   alert(
      //     err?.response?.data?.message ??
      //     "Something went wrong. Please try again later. error: 371"
      //   );
      //   if (
      //     err?.response?.data?.message.includes(
      //       "You don't have enough credits"
      //     )
      //   ) {
      //     PopupStore.setGetMoreCredits(true);
      //   }
      //   // alert("Something went wrong. Please try again later. error: 29");
      // });
    } catch (error) {
      console.log(error);

      InterviewStore.setLoading(false);
      alert(`Something went wrong. ${error}`);
    }
  };

  /* ------------------- Speech recognition section methods ------------------- */
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();

  const videoRef = useRef(null);
  let screenRecordBlob = null;

  const handleStartVideo = async () => {
    try {
      const videoConstraints = isSafariBrowser() ? true : { video: true };
      const stream =
        await navigator.mediaDevices.getUserMedia(videoConstraints);
      videoRef.current.srcObject = stream;
      videoRef.current.style.transform = "scaleX(-1)"; // Mirror the video horizontally
      if (InterviewStore.cameraNotification) {
        InterviewStore.setNotificationText("Camera turned on");
        InterviewStore.setNotificationIcon(<IoVideocamOutline />);
        InterviewStore.setNotificationTimer(true);
        InterviewStore.setShowNotification(true);
      }
      return true;
    } catch (error) {
      console.error("Error accessing camera:", error);
      if (!InterviewStore.isInterviewCompleted) {
        if (isSafariBrowser() && error.name === "NotAllowedError") {
          InterviewStore.setNotificationText(
            "Safari requires you to allow camera access. Please check Safari > Settings > Websites > Camera and allow access for this site.",
          );
        } else {
          InterviewStore.setNotificationText("Error accessing camera");
        }
        InterviewStore.setNotificationIcon(<IoVideocamOutline />);
        InterviewStore.setNotificationTimer(true);
        InterviewStore.setShowNotification(true);
      }
      return false;
    }
  };

  useEffect(() => {
    // InterviewStore.appendUserVoiceInput(transcript);

    if (!speaking) InterviewStore.setTranscription(transcript);
  }, [transcript]);

  // useEffect(() => {
  //   if (!isRecording) {
  //     setIsMutedd(false);
  //   }
  //   if (mobileView && !speaking && isRecording) {
  //     let allTranscript = results.map((result) => result?.transcript).join(" ");
  //     console.log(allTranscript);
  //     InterviewStore.setTranscription(allTranscript);
  //   }
  // }, [isRecording]);

  useEffect(() => {
    if (!mobileView) return;
    setIsMutedd(isRecording);
    // if (!isRecording) {
    //   setIsMutedd(false);
    // }
  }, [isRecording]);

  useEffect(() => {
    if (InterviewStore.sttModule === "azure-stt") return; // stop the below code if the stt module is azure
    if (!mobileView) return;
    console.log("results", results);
    if (results?.length === 0) return;
    let filteredTranscript = [];
    results.forEach((result) => {
      if (result?.timestamp > InterviewStore.lastSubmitTimeStamp) {
        filteredTranscript.push(result?.transcript);
      }
    });
    console.log(filteredTranscript);
    let allTranscript = filteredTranscript.join(" ");
    console.log("💥💥💥💥💥💥 -> ", allTranscript);
    // InterviewStore.setTranscription(allTranscript);
    InterviewStore.setUserVoiceInput(allTranscript);
    InterviewStore.setTranscription("");
  }, [results]);

  useEffect(() => {
    if (InterviewStore.sttModule === "azure-stt") return; // stop the below code if the stt module is azure
    if (!mobileView) return;
    console.log(interimResult);
    if (interimResult === undefined) return;

    InterviewStore.setTranscription(interimResult);
  }, [interimResult]);

  const handleStopVideo = () => {
    try {
      const stream = videoRef.current.srcObject;
      const tracks = stream.getTracks();

      tracks.forEach(function (track) {
        track.stop();
      });

      videoRef.current.srcObject = null;
      if (InterviewStore.cameraNotification) {
        InterviewStore.setNotificationText("Camera turned off");
        InterviewStore.setNotificationIcon(<IoVideocamOffOutline />);
        InterviewStore.setNotificationTimer(true);
        InterviewStore.setShowNotification(true);
      }
    } catch (error) {
      console.log(error);
      // alert("Error stopping your camera");
      if (!InterviewStore.isInterviewCompleted) {
        InterviewStore.setNotificationText("Error Stopping your camera");
        InterviewStore.setNotificationTimer(true);
        InterviewStore.setNotificationIcon(<IoVideocamOffOutline />);
        InterviewStore.setShowNotification(true);
      }
    }
  };

  // end of video call section methods

  // volume component methods

  const [volume, setVolume] = useState(50);
  const [isMuted, setIsMuted] = useState(false);

  const handleVolumeChange = (e) => {
    setVolume(e.target.value);
  };

  const toggleMute = () => {
    setIsMuted(!isMuted);
  };

  // end of volume component methods

  // action icons component methods

  const [isMutedd, setIsMutedd] = useState(false);
  const [isCameraOn, setIsCameraOn] = useState(false);
  const [isCCOn, setIsCCOn] = useState(true);
  const [mobileView, setMobileView] = useState(false);
  const [isUser, setIsUser] = useState(true);
  // const [sttModule, setSttModule] = useState("azure-stt"); // if you stop azure stt then make it null

  /* ----------------- to change the state of the mobile view ----------------- */
  useEffect(() => {
    setIsUser(localStorage.getItem("isUser"));
    if (window.innerWidth < 768) {
      setMobileView(true);
      console.log("mobile");
    } else {
      console.log("web");
      setMobileView(false);
    }
  }, []);

  const toggleDomMic = (state) => {
    try {
      const micButton = window.document.getElementById(
        state ? "unMuteMic" : "muteMic",
      );
      if (micButton) {
        return micButton.click();
      }
    } catch (error) {
      console.log(error);
    }
  };
  // useEffect(() => {
  //   if (isInterviewCompleted) {
  //     alert("hello");
  //   } else {
  //     alert("bye");
  //   }
  // },[isInterviewCompleted]);

  const toggleMuted = (prop) => {
    let state = prop ?? !isMutedd;
    if (isInterviewCompleted) {
      state = false;
    }

    console.log(state);

    setIsMutedd(state);

    if (InterviewStore.sttModule === "azure-stt") return; // stop the below code if the stt module is azure

    if (mobileView) return toggleDomMic(state);

    if (mobileView) {
      setTimeout(() => {
        if (state && !isRecording) {
          startSpeechToText();
          // listen();
        } else {
          stopSpeechToText();
          // stop();
        }
      }, 1000);
    } else {
      setTimeout(() => {
        if (state) {
          SpeechRecognition.startListening({
            language: "en-IN",
            continuous: true,
          });
          // listen();
        } else {
          SpeechRecognition.stopListening();
          // stop();
        }
      }, 1000);
    }
  };

  const toggleCamera = async (prop) => {
    let state = prop ?? !isCameraOn;
    console.log(state);

    setIsCameraOn(state);

    if (state) {
      const status = await handleStartVideo();

      return status;
    } else {
      handleStopVideo();

      return true;
    }
  };

  const toggleCC = () => {
    setIsCCOn(!isCCOn);
  };

  // micro phone component methods
  const audioRef = useRef(null);
  let mediaStream = null;
  const handleStartAudio = async () => {
    try {
      const audioConstraints = isSafariBrowser()
        ? true
        : {
            noiseSuppression: InterviewStore.noiseCancellation,
            echoCancellation: InterviewStore.noiseCancellation,
            autoGainControl: false,
          };
      mediaStream = await navigator.mediaDevices.getUserMedia({
        audio: audioConstraints,
      });
      audioRef.current.srcObject = mediaStream;
    } catch (error) {
      console.error("Error accessing microphone:", error);
      if (isSafariBrowser() && error.name === "NotAllowedError") {
        alert(
          "Safari requires you to allow microphone access. Please check Safari > Settings > Websites > Microphone and allow access for this site.",
        );
      } else {
        alert(
          "Error accessing your microphone, please check your microphone settings",
        );
      }
    }
  };

  const handleStopAudio = () => {
    try {
      if (mediaStream) {
        mediaStream.getTracks().forEach((track) => track.stop());
        audioRef.current.srcObject = null;
      }
    } catch (error) {
      console.log(error);
      alert("Error stopping your microphone");
    }
  };

  const checkMicrophonePermission = async () => {
    try {
      // Check the permission status using the Permissions API
      const permissionStatus = await navigator.permissions.query({
        name: "microphone",
      });

      // Update the permission status based on the result
      // alert(permissionStatus.state);

      // Listen for permission state changes
      // permissionStatus.onchange = () => {
      //   alert(permissionStatus.state);
      // };

      return permissionStatus.state;
    } catch (err) {
      console.error("Error checking microphone permission:", err);
      alert("Unable to access your microphone");
      return "denied";
    }
  };

  const checkPermission = async () => {
    if (mobileView) {
      try {
        toggleMuted(true);
        toggleCamera(true);
      } catch (error) {
        alert(`Please allow microphone permission to start interview ${error}`);
      }
      // PopupStore.setRequest(true);
      return true;
    }

    //  if(await checkMicrophonePermission() == "denied")
    //  {
    //   PopupStore.setMicroPhone(3);
    //   // alert(PopupStore.microPhone)
    //   PopupStore.setRequestPermission(true);

    //   return;
    //  }

    try {
      const audioConstraints = isSafariBrowser()
        ? true
        : {
            noiseSuppression: InterviewStore.noiseCancellation,
            echoCancellation: InterviewStore.noiseCancellation,
            autoGainControl: false,
          };
      const permission = await navigator.mediaDevices.getUserMedia({
        audio: audioConstraints,
      });
      if (permission) {
        console.log("Permission Granted");
        toggleMuted(true);
        const status = await toggleCamera(true);

        try {
          const customSetting = JSON.parse(
            localStorage.getItem("customSettings"),
          );
          const videostatus = customSetting.find(
            (setting) => setting?.name === "video",
          ).value;

          console.log(videostatus);
          if (!status && videostatus) {
            return status;
          }
          // PopupStore.setRequest(true)
          return true;
        } catch (error) {
          // PopupStore.setRequest(true)
          return true;
        }
        // PopupStore.setRequest(true)
        return true;
      } else {
        console.log("Permission Denied");
        // PopupStore.setRequest(false)
        return false;
      }
    } catch (error) {
      console.log(error);
      // PopupStore.setRequest(false)

      InterviewStore.setShowNotification(true);
      return false;
    }

    // access only the microphone
  };

  const submitAnswerButton = () => {
    return (
      <SubmitButton
        loading={InterviewStore.loading}
        onClick={continueTheInterview}
        transcript={
          InterviewStore.userVoiceInput + " " + InterviewStore.transcript
        }
        speaking={speaking}
        isUserSpeaking={InterviewStore.isUserSpeaking}
      />

      // <button
      //   onClick={() => {
      //     continueTheInterview();
      //   }}
      //   className={`py-3 px-4 text-sm h-[60px] w-1/2 gil-bold ml-2 rounded-md ${
      //     InterviewStore.loading
      //       ? "bg-gray-500 cursor-not-allowed"
      //       : "bg-blue-500 hover:shadow-xl"
      //   } text-white`}
      //   disabled={InterviewStore.loading}
      // >
      //   {InterviewStore.loading ? "Loading..." : "Submit your answer"}
      // </button>
    );
  };

  // const start = async() => {
  //   if (PopupStore.request) {
  //     setInterviewStarted(true);
  //     InterviewStore.setLoading(true);
  //     return initiateInterview();
  //   }

  //   alert(
  //     "Please allow microphone and Camera permission to start interview"
  //   );
  //   PopupStore.setRequestPermission(true)
  // }

  const RetryStartInterviewButton = () => {
    return (
      <>
        <Tooltip
          id="startinterviewtooltip"
          position="bottom-end"
          content="Click here to start interview"
        >
          <Button
            disabled={InterviewStore.loading}
            onClick={async () => {
              if (await checkPermission()) {
                const element = document.documentElement;

                setInterviewStarted(true);
                InterviewStore.setIsInterviewStarted(true);
                InterviewStore.setLoading(true);
                return initiateInterview();
              }

              alert(
                "Please allow microphone and Camera permission to start interview",
              );
            }}
            size={{ initial: "2", md: "3", lg: "4" }}
            variant={InterviewStore.loading ? "soft" : "solid"}
            className={`mt-2 md:py-3 lg:py-4 py-2 md:px-4 lg:px-5 px-3 md:text-sm lg:text-lg text-xs h-[50px] md:h-[60px] lg:h-[80px] w-[150px] gil-bold ml-2 rounded-md ${
              InterviewStore.loading
                ? "bg-primary2 cursor-not-allowed text-text_color3 border border-primary"
                : "bg-primary hover:shadow-xl text-white"
            } `}
          >
            <Text weight="regular" className="gil-med">
              Start Interview
            </Text>
          </Button>
        </Tooltip>
      </>
    );
  };

  const startInterviewButton = () => {
    return (
      <>
        <Button
          id="start-interview-btn"
          disabled={InterviewStore.loading}
          onClick={async () => {
            if (localStorage.getItem("userImage")) {
              // Now actually start the interview
              if (await checkPermission()) {
                setInterviewStarted(true);
                InterviewStore.setIsInterviewStarted(true);
                InterviewStore.setLoading(true);
                return askUserAboutRecording();
              }
            }

            PopupStore.setImageCapture(true);
            setInterviewStarted(false);
            InterviewStore.setIsInterviewStarted(false);
            return;

            // Show precautions popup first
            PopupStore.setShowPrecautions(true);
          }}
          size={{ initial: "2", md: "4", lg: "4" }}
          variant={InterviewStore.loading ? "soft" : "solid"}
          color={"#FF6B00"}
          className="mt-2 w-[150px] md:text-sm lg:text-lg text-xs"
        >
          {!continueInterviewId ? "Start Interview" : "Continue Interview"}
        </Button>
      </>
    );
  };

  const navigateToReportScreen = (id) => {
    const role = JSON.parse(localStorage.getItem("user"))?.role.role;
    if (role === "company") {
      return navigate(`/company/report/${interviewDetails?._id ?? id}`, {
        replace: true,
      });
    }
    navigate(`/dashboard/report/${interviewDetails?._id ?? id}`, {
      replace: true,
    });
  };

  const hitResultAPI = (id) => {
    if (InterviewStore.loading) return;
    if (isResultGenerated) return;
    InterviewStore.setLoading(true);
    localStorage.removeItem("career");
    const body = {
      interviewId:
        interviewDetails?._id ?? continueInterviewId ?? startInterviewId,
    };
    try {
      let newBody = body;
      newBody = {
        ...newBody,
        cluster: getclusterbyDomain(),
      };
      axios
        .post(`${apiLink}/interview/result-v2`, newBody)
        .then((res) => {
          if (res.status === 200) {
            setIsResultGenerated(true);
            if (isFeedbackGiven) {
              navigateToReportScreen();
            } else {
              setShowFeedbackForm(true);
            }
            // if (
            //   window.confirm(
            //     "Your result generated successfully. Do you want to see your result?"
            //   )
            // ) {
            //   return navigate(`/report/${interviewDetails?._id}`, {
            //     replace: true,
            //   });
            // }
            // alert("Wait for the timer to end.");
          } else
            alert(
              "Something went wrong. Unable to generate result. error: 567",
            );
        })
        .catch((err) => {
          console.log(err);

          alert(`${err?.response?.data?.message}`);
        });
    } catch (error) {
      console.log(error);
    } finally {
      // setShowFeedbackForm(true);
    }
  };

  const showResultButton = () => {
    return (
      <>
        <Button
          disabled={InterviewStore.loading}
          id="showResult"
          onClick={() => {
            InterviewStore.setForceStopMic(true);

            // Exit fullscreen when showing results
            try {
              const isFullScreen =
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement;
              if (isFullScreen) {
                if (document.exitFullscreen) {
                  document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                  document.webkitExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                  document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                  document.msExitFullscreen();
                }
              }
            } catch (fullscreenError) {
              console.warn("Fullscreen exit failed:", fullscreenError);
            }

            hitResultAPI();
            setShowCountDownTimer(true);
          }}
          size={{ initial: "2", md: "4", lg: "4" }}
          variant={InterviewStore.loading ? "soft" : "solid"}
          color={InterviewStore.loading ? "gray" : "green"}
          className={`mt-2 w-[60%] ml-2 md:text-sm lg:text-lg text-xs ${
            InterviewStore.loading ? " cursor-not-allowed " : ""
          }`}
        >
          Show My Results
        </Button>
      </>
    );
  };

  const saveBlobToMobx = (screenRecordBlob) => {
    const reader = new FileReader();
    reader.onload = function () {
      const blobString = reader.result; // Convert the Blob to a string
      // localStorage.setItem( 'myBlob', blobString );
      InterviewStore.setScreenRecorder(blobString);

      console.log("Blob saved to mobx.");
    };
    reader.readAsDataURL(screenRecordBlob);
  };

  const [isVideoUploaded, setIsVideoUploaded] = useState(true);

  const downloadRecording = async (blob) => {
    console.log(screenRecordBlob);
    //  const url = URL.createObjectURL( blob );
    //  const xhr = new XMLHttpRequest();
    // xhr.open('GET', url, true);
    // xhr.responseType = 'blob';

    //  xhr.onload = function ( e )
    //  {
    //    console.log( this.status );
    //   if (this.status === 200) {
    //     const blob = new Blob([this.response], { type: 'video/webm' });

    //     // Save the blob to local storage
    //     localStorage.setItem('recording', JSON.stringify(blob));
    //     console.log('Video saved to local storage.');
    //   }
    // };

    // xhr.send();
    if (screenRecordBlob !== null) {
      setIsVideoUploaded(false);
      InterviewStore.setIsVideoUploaded(false);
      try {
        console.log(screenRecordBlob);
        saveBlobToMobx(screenRecordBlob);
        //  localStorage.setItem( "record", screenRecordBlob );

        const url = URL.createObjectURL(screenRecordBlob);
        console.log(url);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;

        // Determine file extension based on MIME type
        let fileExtension = "mp4";
        if (screenRecordBlob.type.includes("webm")) {
          fileExtension = "webm";
        } else if (screenRecordBlob.type.includes("mp4")) {
          fileExtension = "mp4";
        }

        a.download = `recording.${fileExtension}`;
        document.body.appendChild(a);
        await uploadRecordingToServer(screenRecordBlob);
        setIsVideoUploaded(true);
        InterviewStore.setIsVideoUploaded(true);
        // a.click();
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } catch (error) {
        setIsVideoUploaded(true);
        InterviewStore.setIsVideoUploaded(true);
        console.log(error);
      }
    } else {
      setIsVideoUploaded(true);
      InterviewStore.setIsVideoUploaded(true);
      return;
    }
  };

  const uploadRecordingToServer = async (blob) => {
    if (!blob) {
      console.log("no blob");
      return;
    }

    // fetch interviewdetails from local storage
    const interviewDetails = JSON.parse(
      localStorage.getItem("interviewDetails"),
    );

    // Determine file extension based on MIME type
    let fileExtension = "mp4";
    if (blob.type.includes("webm")) {
      fileExtension = "webm";
    } else if (blob.type.includes("mp4")) {
      fileExtension = "mp4";
    }

    InterviewStore.setVideoUpload(true);
    const response = await uploadFileToAzure(
      `${interviewDetails?._id}.${fileExtension}`,
      blob,
      { action: "recording" },
      (percentCompleted) => {
        InterviewStore.setVideoUploadProgress(percentCompleted);
      },
    );
    InterviewStore.setVideoUpload(false);
    if (response?.url) {
      InterviewStore.updateInterviewById(interviewDetails?._id, {
        recording: response.url,
      });
    }
  };

  useEffect(() => {
    return () => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
    };
  }, [stream]);

  useEffect(() => {
    try {
      if (customSetting[0]?.value) {
        setIsCameraOn(true);
        handleStartVideo();
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    // disable the all camera and mic access

    if (isInterviewCompleted) {
      try {
        InterviewStore.setCameraNotification(false);
        InterviewStore.setForceStopMic(true);
        toggleDomMic(false);
        InterviewStore.setSpeechResult([]);
        toggleCamera(false);
        toggleMuted(false);
        InterviewStore.setTranscription("");
        InterviewStore.setUserVoiceInput("");
        InterviewStore.updateInterviewCompletedTime(interviewDetails?._id);
        if (mediaRecorder && mediaRecorder.state !== "inactive") {
          mediaRecorder.stop();
          setStream(null);
          setMediaRecorder(null);
        }
        downloadRecording();

        // uploadRecordingToServer(screenRecordBlob);
        // handleStopVideo();
        // navigator.mediaDevices.getUserMedia({ video: false });
      } catch (error) {}
    }
  }, [isInterviewCompleted]);

  const showButtons = () => {
    // return showResultButton(); // comment this line later

    if (isInterviewCompleted) {
      InterviewStore.setForceStopMic(true);

      // Exit fullscreen when interview is completed
      try {
        const isFullScreen =
          document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.mozFullScreenElement ||
          document.msFullscreenElement;
        if (isFullScreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        }
      } catch (fullscreenError) {
        console.warn("Fullscreen exit failed:", fullscreenError);
      }

      hitResultAPI();
      setShowCountDownTimer(true);
      return showResultButton();
    }

    if (retryStartInterview && !interviewStarted) {
      return RetryStartInterviewButton();
    }

    if (interviewStarted) {
      return submitAnswerButton();
    } else {
      return startInterviewButton();
    }
  };

  // end of micro phone component methods

  const getMutButton = () => {
    // return muteButtonForChrome();
    if (InterviewStore.sttModule === "azure-stt")
      return (
        <div>
          <AzureSpeechToText isMutedd={isMutedd} toggleMuted={toggleMuted} />
        </div>
      );
    else if (InterviewStore.sttModule === "browser-stt")
      return muteButtonForChrome();
    else if (mobileView) return <MuteButton />;
  };

  const iconRowComponent = () => {
    return (
      <div
        className="flex justify-center items-center md:items-start lg:items-start md:gap-4 lg:gap-4 gap-3"
        onMouseLeave={async () => {
          setIsNoiseCancellation(false);
        }}
      >
        <div
          className="md:ml-0 lg:ml-0 ml-3 pl-2 flex justify-center mt-2 md:gap-2 lg:gap-4 gap-3"
          onMouseEnter={() => setIsNoiseCancellation(true)}
        >
          {isNoiseCancellation && (
            <Card
              variant="surface"
              style={{
                position: "absolute",
                marginTop: "-50px",
                padding: "12px 16px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
                zIndex: 1000,
                background: theme === "dark" ? "#18181b" : "white",
                color: theme === "dark" ? "white" : "#222",
                boxShadow: "var(--shadow-4)",
              }}
            >
              <Text
                weight="regular"
                size="2"
                style={{ color: theme === "dark" ? "white" : "#222" }}
                className="gil-med"
              >
                Noise Cancellation
              </Text>
              <Switch
                checked={InterviewStore.noiseCancellation}
                onCheckedChange={(checked) => {
                  InterviewStore.noiseCancellation = checked;
                }}
              />
            </Card>
          )}

          <div id="mute-btn">{getMutButton()}</div>
        </div>{" "}
        {showButtons()}
        {/* <button
          onClick={() => {
            InterviewStore.setLastSubmitTimeStamp();
          }}
        >
          reset
        </button> */}
        <Flex
          direction="column"
          align="center"
          gap="4"
          className="mt-1.5 md:mt-5 pl-3"
        >
          <Tooltip id="cameratooltip" content="Camera" position="top">
            <IconButton
              id="camera-btn"
              size={window.innerWidth < 768 ? "2" : "4"}
              variant={"ghost"}
              color={"gray"}
              style={{
                border: "1px solid rgba(204, 204, 204, 0.2)",
              }}
              onClick={async () => {
                try {
                  InterviewStore.setCameraNotification(true);
                  console.log(
                    "hello",
                    customSetting[0]?.value,
                    interviewStarted,
                  );
                  if (
                    !interviewStarted &&
                    !customSetting[0]?.value &&
                    !customSetting[7]?.value
                  ) {
                    toggleCamera(!isCameraOn);
                  } else if (
                    !interviewStarted &&
                    !customSetting[0]?.value &&
                    !customSetting[7]?.value
                  ) {
                    toggleCamera(!isCameraOn);
                  } else if (
                    interviewStarted &&
                    !customSetting[0]?.value &&
                    !customSetting[7]?.value
                  ) {
                    toggleCamera(!isCameraOn);
                  } else {
                    InterviewStore.setTurnOffCamera(true);
                    setOffCameraPopUp(true);
                  }
                } catch (error) {
                  InterviewStore.setCameraNotification(true);
                  toggleCamera(!isCameraOn);
                  console.log(error);
                }
              }}
            >
              {isCameraOn ? (
                <MdOutlineVideocam className="text-lg md:text-2xl lg:text-3xl" />
              ) : (
                <MdOutlineVideocamOff className="text-lg md:text-2xl lg:text-3xl" />
              )}
            </IconButton>
          </Tooltip>
          {/* <Text size="1" color="gray" className="hidden md:block lg:block">
            Camera
          </Text> */}
        </Flex>
        {/* <div className="flex flex-col items-center">
          <div
            className={`border ${
              isCCOn ? "border-blue-500" : "border-gray-300"
            } p-4 rounded-lg cursor-pointer`}
            onClick={toggleCC}
          >
            {isCCOn ? (
              <MdClosedCaptionOff className="text-blue-500 text-3xl" />
            ) : (
              <MdClosedCaptionDisabled className="text-gray-500 text-3xl" />
            )}
          </div>
          <span className="mt-2 text-sm opacity-30">CC</span>
        </div> */}
      </div>
    );
  };

  const CameraPopUp = () => {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-700 bg-opacity-40 z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-xs w-full text-center">
          <p className="mb-4">
            You can't turn off the camera during the interview.
          </p>
          <button
            onClick={() => {
              setOffCameraPopUp(false);
              InterviewStore.setTurnOffCamera(false);
            }}
            className="px-4 py-2 bg-primary text-white rounded-lg"
          >
            OK
          </button>
        </div>
      </div>
    );
  };

  const volumeComponent = () => {
    return (
      <div className="flex flex-col items-start">
        <div className="border border-gray-200 rounded-lg p-4 flex items-center">
          {isMuted ? (
            <MdVolumeDown
              className="text-gray-500 text-2xl"
              onClick={toggleMute}
            />
          ) : (
            <MdVolumeUp
              className="text-gray-500 text-2xl"
              onClick={toggleMute}
            />
          )}
          <input
            type="range"
            min="0"
            max="100"
            value={volume}
            onChange={handleVolumeChange}
            className="ml-3 h-2 flex-grow rounded-lg bg-gray-200 focus:outline-none"
          />
        </div>
        <p className="mt-3 opacity-30 ml-3 gil-med text-sm">Volume</p>
      </div>
    );
  };

  const volumeButton = () => {
    return (
      <div className="flex flex-col items-center">
        <div
          className={`border ${
            false ? "border-blue-500" : "border-gray-300"
          } p-3 md:p-4 lg:p-4 rounded-lg cursor-pointer`}
          // onClick={() => toggleCamera(!isCameraOn)}
        >
          {false ? (
            <MdOutlineVolumeUp className="text-blue-500 text-lg md:text-2xl lg:text-3xl" />
          ) : (
            <MdOutlineVolumeUp className="text-gray-500 text-lg md:text-2xl lg:text-3xl" />
          )}
        </div>
        <span className="mt-2 text-sm opacity-30 hidden md:block lg:block">
          Volume
        </span>
      </div>
    );
  };

  const settingsComponent = () => {
    return (
      <Flex
        direction="column"
        align="center"
        gap="4"
        className="mt-1.5 md:mt-5  "
      >
        <Tooltip id="testmediatooltip" content="Settings" position="top">
          <IconButton
            id="settings-btn"
            size={window.innerWidth < 768 ? "2" : "4"}
            variant={"ghost"}
            color={"gray"}
            onClick={() => {
              PopupStore.setTestMedia(true);
              PopupStore.setTestMediaOpeningThroughSettings(true);
            }}
            style={{
              border: "1px solid rgba(204, 204, 204, 0.2)",
            }}
          >
            <IoSettingsOutline className="text-lg md:text-2xl lg:text-3xl" />
          </IconButton>
        </Tooltip>
        {/* <Text size="1" color="gray" className="hidden md:block lg:block">
          Settings
        </Text> */}
      </Flex>
    );
  };

  const leaveMeetingButton = () => {
    const navigateToDashboard = () => {
      navigate("/dashboard");
    };

    //this is return
    return (
      <div className="flex ">
        <Flex
          direction="column"
          align="center"
          gap="4"
          className="mt-1.5 mx-3 md:mx-0 md:mt-5"
        >
          <Tooltip id="compilertooltip" content="Code Editor" position="top">
            <IconButton
              id="code-editor-btn"
              size={window.innerWidth < 768 ? "2" : "4"}
              variant="ghost"
              color="gray"
              onClick={() => PopupStore.setCompiler(true)}
              style={{
                border: "1px solid rgba(204, 204, 204, 0.2)",
              }}
            >
              <FaCode className="text-lg md:text-2xl lg:text-3xl" />
            </IconButton>
          </Tooltip>
          {/* <Text size="1" color="gray" className="hidden md:block lg:block">
            Code Editor
          </Text> */}
        </Flex>
        {/* <div className="flex flex-col items-center">
        <div
          className="border border-gray-300 hover:border-red-500 p-3 md:p-4 lg:p-4 rounded-lg cursor-pointer"
          onClick={navigateToDashboard}
        >
          <MdOutlineLogout className="text-red-500 text-lg md:text-2xl lg:text-3xl" />
        </div>
        <span className="mt-2 text-sm opacity-30 hidden md:block lg:block">
          Abort
        </span>
      </div> */}
      </div>
    );
  };

  const feedbackForm = () => {
    const onSubmitFeedback = async () => {
      /* ----------- turn off the camera and mic after interview is done ---------- */
      // toggleMuted(true);
      // toggleCamera(true);

      /* ------------------------- Navigate to report page ------------------------ */
      if (isResultGenerated && isVideoUploaded) {
        // Exit fullscreen when submitting feedback
        try {
          const isFullScreen =
            document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement;
          if (isFullScreen) {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
              document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
              document.msExitFullscreen();
            }
          }
        } catch (fullscreenError) {
          console.warn("Fullscreen exit failed:", fullscreenError);
        }

        if (from === "user-reaidy") {
          await localStorage.clear();
          if (startInterviewId !== null) {
            if (environment === "production") {
              window.location.href = `https://user.reaidy.io/dashboard/interview-report/${startInterviewId}`;
            } else {
              window.location.href = `https://qa-user.reaidy.io/dashboard/interview-report/${startInterviewId}`;
            }
          } else if (continueInterviewId !== null) {
            if (environment === "production") {
              window.location.href = `https://user.reaidy.io/dashboard/interview-report/${continueInterviewId}`;
            } else {
              window.location.href = `https://user.reaidy.io/dashboard/interview-report/${continueInterviewId}`;
            }
          } else {
            return (window.location.href = `https://user.reaidy.io`);
          }
          return;
        }
        navigateToReportScreen();
        setIsFeedbackGiven(true);
        setShowFeedbackForm(false);
        return true;
      } else {
        alert("Please wait for the video to upload.");
      }
    };

    return (
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
        <div
          // key={key}
          className="rounded-xl z-50 shadow-sm p-9 hover:shadow-lg transition duration-300 w-[90vw] md:w-[40vw] h-[80vh] md:min-h-fit md:h-[65vh] min-h-[300px] flex flex-col justify-between relative md:overflow-y-auto overflow-y-auto"
          style={{
            background: theme === "dark" ? "#18181b" : "#fff",
            color: theme === "dark" ? "#fff" : "#222",
          }}
        >
          <div className="w-[100%] justify-between flex items-center">
            <div>
              <Flex direction="column" gap="2" align="center" justify="center">
                {InterviewStore.isInterviewCompleted &&
                  !InterviewStore.isVideoUploaded && (
                    <Card
                      variant="surface"
                      style={{
                        background: "#FFF8E1",
                        minWidth: 220,
                        padding: 0,
                      }}
                    >
                      <Flex align="center" gap="2" px="4" py="2">
                        <AiOutlineClockCircle
                          size="1.2rem"
                          style={{ color: "#FFA726" }}
                        />
                        <Text size="2" color="amber">
                          Your video is uploading...
                        </Text>
                      </Flex>
                    </Card>
                  )}
                {InterviewStore.isVideoUploaded &&
                  InterviewStore.recordPermission && (
                    <Card
                      variant="surface"
                      style={{
                        background: "#E8F5E9",
                        minWidth: 220,
                        padding: 0,
                      }}
                    >
                      <Flex align="center" gap="2" px="4" py="2">
                        <AiOutlineCheckCircle
                          size="1.2rem"
                          style={{ color: "#43A047" }}
                        />
                        <Text size="2" color="green">
                          Your video is uploaded
                        </Text>
                      </Flex>
                    </Card>
                  )}
              </Flex>
            </div>
            <button
              className=" text-primary px-4 py-2 rounded-md"
              onClick={async () => {
                if (isResultGenerated && isVideoUploaded) {
                  // Exit fullscreen when skipping feedback
                  try {
                    const isFullScreen =
                      document.fullscreenElement ||
                      document.webkitFullscreenElement ||
                      document.mozFullScreenElement ||
                      document.msFullscreenElement;
                    if (isFullScreen) {
                      if (document.exitFullscreen) {
                        document.exitFullscreen();
                      } else if (document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                      } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                      } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                      }
                    }
                  } catch (fullscreenError) {
                    console.warn("Fullscreen exit failed:", fullscreenError);
                  }

                  setShowFeedbackForm(false);
                  if (from === "user-reaidy") {
                    await localStorage.clear();
                    if (startInterviewId !== null) {
                      if (environment === "production") {
                        window.location.href = `https://user.reaidy.io/dashboard/interview-report/${startInterviewId}`;
                      } else {
                        window.location.href = `https://qa-user.reaidy.io/dashboard/interview-report/${startInterviewId}`;
                      }
                    } else if (continueInterviewId !== null) {
                      if (environment === "production") {
                        window.location.href = `https://user.reaidy.io/dashboard/interview-report/${continueInterviewId}`;
                      } else {
                        window.location.href = `https://qa-user.reaidy.io/dashboard/interview-report/${continueInterviewId}`;
                      }
                    } else {
                      if (environment === "production") {
                        return (window.location.href = `https://user.reaidy.io`);
                      } else {
                        return (window.location.href = `https://qa-user.reaidy.io`);
                      }
                    }
                    return;
                  }
                  navigateToReportScreen();
                } else {
                  alert("Please wait for the video to upload.");
                }
              }}
            >
              Skip
            </button>
          </div>

          <span className="flex justify-between items-center pb-3">
            <h1
              className="text-center text-3xl gil-bold"
              style={{
                color: theme === "dark" ? "#fff" : "#222",
              }}
            >
              {" "}
              Interview Completed
            </h1>
          </span>
          <InterviewFeedback onSubmit={onSubmitFeedback} theme={theme} />
        </div>
      </div>
    );
  };

  const storeBackSpace = () => {
    // this method will remove the word in the setenece
    if (mobileView) {
      InterviewStore.setLastSubmitTimeStamp(); // this is for mobile view speech to text
      InterviewStore.backSpace(true); // remove the word in setenece
    } else {
      InterviewStore.backSpace(); // remove the word in setenece
      resetTranscript(); // resent the transcription generated by package
    }
  };

  const backSpace = () => {
    console.log("backspace");
    // slice the last word from the sentence of transcript then update the transcript
    let totalTranscript = transcript
      ? backSpaceTranscription + " " + transcript
      : backSpaceTranscription;
    console.log(totalTranscript);
    const transcriptArray = totalTranscript.split(" ");
    transcriptArray.pop();
    const updatedTranscript = transcriptArray.join(" ");
    console.log(updatedTranscript);
    setBackSpaceTranscription(updatedTranscript);
    resetTranscript();
  };

  const manualInterviewCompleted = async () => {
    // ask interviewee to is interview completed or not
    const response = window.confirm("Is interview completed?");

    if (response) {
      InterviewStore.setCameraNotification(false);
      InterviewStore.setNotificationText("Interview Stopped");
      InterviewStore.setNotificationIcon(
        <RiRecordCircleLine className="text-[#FA3532] text-xl" />,
      );
      InterviewStore.setShowNotification(true);
      InterviewStore.setIsInterviewCompleted(true);

      // Exit fullscreen when interview is manually completed
      try {
        const isFullScreen =
          document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.mozFullScreenElement ||
          document.msFullscreenElement;
        if (isFullScreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        }
      } catch (fullscreenError) {
        console.warn("Fullscreen exit failed:", fullscreenError);
      }

      setTimeout(() => {}, 2000);
      InterviewStore.setIsInterviewCompleted(true);

      setIsInterviewCompleted(true);
    }
  };

  const resetTheTrasncription = () => {
    setBackSpaceTranscription("");
    InterviewStore.resetUserVoiceInput();
    resetTranscript();

    if (mobileView) {
      InterviewStore.setLastSubmitTimeStamp(); // this is for mobile view speech to text
      InterviewStore.resetTranscript();
    }

    // InterviewStore.resetTranscript()
  };

  const onChangeCC = (e) => {
    const value = e?.target?.value;
    let modifiedValue = value.replace("You: ", "");
    InterviewStore.setUserVoiceInput(modifiedValue);
    InterviewStore.resetTranscript();
    resetTranscript();

    if (mobileView) {
      InterviewStore.setLastSubmitTimeStamp(); // this is for mobile view speech to text
    }
  };

  // cc scroll to bottom methods and functions
  const ccRef = useRef(null);
  useEffect(() => {
    // Scroll to the bottom when the component updates
    scrollToBottom();
  }, [transcript]); // Assuming InterviewStore.transcript is the value that changes

  const scrollToBottom = () => {
    try {
      if (ccRef.current) {
        ccRef.current.scrollTop = ccRef.current.scrollHeight;
      }
      // const id = "chat-input";
      // const element = document.getElementById(id);
      // if (element) {
      //   element.scrollIntoView({
      //     behavior: "smooth",
      //     block: "end",
      //     inline: "nearest",
      //   });
      // }
    } catch (error) {}
  };

  const onBack = () => {
    if (from === "user-reaidy") {
      if (environment === "production") {
        return (window.location.href = "https://user.reaidy.io/");
      } else {
        return (window.location.href = "https://qa-user.reaidy.io/");
      }
    }
    navigate("/");
  };

  // end of cc scroll bottom
  //get data from url of http://localhost:3000/interview?name=kalyan&level=low&technology=html&question=5
  // const name1 = new URLSearchParams(window.location.search).get("name");
  // const levelOfInterview1 = new URLSearchParams(window.location.search).get("level");
  // const technology1 = new URLSearchParams(window.location.search).get("technology");
  // const noOfQuestions1 = new URLSearchParams(window.location.search).get("question");
  // console.log("detailsssss", name1, levelOfInterview1, technology1, noOfQuestions1);
  const voiceId = JSON.parse(localStorage.getItem("customSettings"))?.find(
    (setting) => setting.name === "aiVoice",
  )?.value;
  const getLucyImg = () => {
    if (voiceId) {
      return audioOptions.find((option) => option.id === voiceId)?.image;
    } else {
      return (
        JSON.parse(localStorage.getItem("Avatar"))?.image ||
        InterviewStore.selectedAudio?.image
      );
    }
  };

  const getLucyName = () => {
    if (voiceId) {
      return audioOptions.find((option) => option.id === voiceId)?.label;
    } else {
      return JSON.parse(localStorage.getItem("Avatar"))?.label;
    }
  };

  const userImg = "https://randomuser.me/api/portraits/men/32.jpg";
  const interviewerImg = "https://randomuser.me/api/portraits/women/44.jpg";
  const aiImg = "https://randomuser.me/api/portraits/women/44.jpg";

  const chatData = [
    {
      sender: "user",
      text: "Lorem ipsum dolor sit amet consectetur. Elit egestas magna",
    },
    {
      sender: "ai",
      text: "Lorem ipsum dolor sit amet consectetur. Elit egestas magna",
    },
    {
      sender: "user",
      text: "Lorem ipsum dolor sit amet consectetur. Elit egestas magna",
    },
    {
      sender: "ai",
      text: "Lorem ipsum dolor sit amet consectetur. Elit egestas magna",
    },
    {
      sender: "user",
      text: "Lorem ipsum dolor sit amet consectetur. Elit egestas magna",
      notDelivered: true,
    },
  ];

  const [isUserSpeaking, setIsUserSpeaking] = useState(false);

  useEffect(() => {
    if (InterviewStore.isUserSpeaking) {
      alert("InterviewStore.isUserSpeaking");
    }
  }, [InterviewStore.isUserSpeaking]);

  useEffect(() => {
    let timeoutId;
    let isSpeaking = false;

    const initializeVoiceDetection = async () => {
      try {
        // Only initialize if microphone is on (isMutedd is true when mic is on)
        if (!isMutedd) {
          InterviewStore.setVoiceVisualizer(false);
          return;
        }

        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        const audioContext = new (
          window.AudioContext || window.webkitAudioContext
        )();
        const sourceNode = audioContext.createMediaStreamSource(stream);
        const analyserNode = audioContext.createAnalyser();
        analyserNode.fftSize = 2048;
        sourceNode.connect(analyserNode);

        const bufferLength = analyserNode.frequencyBinCount;
        const dataArray = new Uint8Array(bufferLength);

        const checkSpeaking = () => {
          // Stop if microphone is off (isMutedd is false when mic is off)
          if (!isMutedd) {
            InterviewStore.setVoiceVisualizer(false);
            return;
          }

          analyserNode.getByteFrequencyData(dataArray);
          let sum = 0;
          for (let i = 0; i < bufferLength; i++) {
            sum += dataArray[i];
          }
          const averageVolume = sum / bufferLength;
          const volumeLevel = Math.round((averageVolume / 255) * 100);

          const isCurrentlySpeaking = volumeLevel > 10;
          InterviewStore.setVoiceVisualizer(isCurrentlySpeaking);

          // Debug logging
          if (isCurrentlySpeaking !== isSpeaking) {
            console.log(
              "Voice detection:",
              isCurrentlySpeaking,
              "Volume:",
              volumeLevel,
              "Mic on:",
              isMutedd,
            );
            isSpeaking = isCurrentlySpeaking;
          }

          timeoutId = requestAnimationFrame(checkSpeaking);
        };

        checkSpeaking();
      } catch (error) {
        console.error("Error accessing microphone:", error);
        InterviewStore.setVoiceVisualizer(false);
      }
    };

    initializeVoiceDetection();

    return () => {
      if (timeoutId) {
        cancelAnimationFrame(timeoutId);
      }
    };
  }, [isMutedd]); // Only depend on microphone mute state, not voiceVisualizer
  // const [theme, setTheme] = useState("dark");
  const [chatFullScreen, setChatFullScreen] = useState(false);
  const [chatInput, setChatInput] = useState("");

  const steps = [
    {
      target: "#start-interview-btn",
      content: "Click here to start your interview!",
      placement: "bottom",
    },
    {
      target: "#conversation-panel",
      content: "This is where your conversation with the AI will appear.",
      placement: "left",
    },
    {
      target: "#interview-details",
      content: "Here you can see the details of your interview.",
      placement: "right",
    },
    // Add more steps as needed
  ];

  // Precautions steps data
  const precautionsSteps = [
    {
      title: "Don't use copy-paste",
      description:
        "Copying content is not allowed during the test. Please answer questions independently.",
      image: copyPasteImg,
    },
    {
      title: "Only you should be visible",
      description:
        "Another person in view will be flagged; the test is being monitored.",
      image: multiFaceImg,
    },
    {
      title: "Tab switching is monitored",
      description:
        "Avoid switching tabs during the test. Tab changes are tracked and may result in warnings.",
      image: tabChangeImg,
    },
    {
      title: "Multi-voice detection",
      description:
        "Background voices are detected and may raise concerns. Ensure a quiet environment.",
      image: multiVoiceImg,
    },
    {
      title: "Face must stay in view",
      description:
        "Moving out of camera view will trigger detection. Stay visible at all times.",
      image: faceOutviewImg,
    },
  ];

  // PrecautionsPopup component
  const PrecautionsPopup = ({ open, onClose, onStart }) => {
    const [step, setStep] = React.useState(0);
    const [isClosing, setIsClosing] = React.useState(false);
    const totalSteps = precautionsSteps.length;
    const current = precautionsSteps[step];

    const handleStart = () => {
      setIsClosing(true);
      setTimeout(() => {
        onStart();
        setIsClosing(false);
      }, 200);
    };

    return (
      <Dialog.Root open={open} onOpenChange={onClose}>
        <Dialog.Content
          className={`fixed left-1/2 top-1/2 z-50 w-full max-w-2xl -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-background/95 p-0 shadow-2xl border flex flex-col overflow-hidden transition-all duration-300 ${
            isClosing
              ? "animate-out fade-out-90 scale-out-95"
              : "animate-in fade-in-90 scale-in-95"
          }`}
          aria-modal="true"
          aria-labelledby="precautions-title"
          style={{ padding: 0 }}
          onPointerDownOutside={(e) => e.preventDefault()}
          onInteractOutside={(e) => e.preventDefault()}
        >
          {/* Custom overlay for background */}
          {/* <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 transition-all" /> */}
          <div className="flex flex-col items-center px-12 py-14 gap-8 md:gap-12 relative z-10">
            <img
              src={current.image}
              alt="Precaution step illustration"
              className="w-full object-contain mb-2"
              style={{ maxWidth: 500, maxHeight: 300 }}
            />
            <div className="flex flex-col items-center w-full">
              <h2
                id="precautions-title"
                className="font-semibold text-2xl text-center mb-2 text-foreground"
              >
                {current.title}
              </h2>
              <p className="text-muted-foreground text-center text-xs mb-4 max-w-xl">
                {current.description}
              </p>
              <div className="flex w-full justify-between items-center gap-2">
                <button
                  className="px-4 py-2 rounded bg-muted text-foreground border text-sm font-medium disabled:opacity-50"
                  onClick={() => setStep((s) => Math.max(0, s - 1))}
                  disabled={step === 0}
                  aria-label="Previous step"
                >
                  Previous
                </button>
                <div className="flex gap-1" aria-label="Step indicators">
                  {precautionsSteps.map((_, idx) => (
                    <span
                      key={idx}
                      className={`inline-block w-2 h-2 rounded-full ${
                        idx === step ? "bg-primary" : "bg-gray-400"
                      }`}
                      aria-current={idx === step ? "step" : undefined}
                    />
                  ))}
                </div>
                {step < totalSteps - 1 ? (
                  <button
                    className="px-4 py-2 rounded bg-primary text-white font-semibold text-sm"
                    onClick={() =>
                      setStep((s) => Math.min(totalSteps - 1, s + 1))
                    }
                    aria-label="Next step"
                  >
                    Next
                  </button>
                ) : (
                  <button
                    className="px-4 py-2 rounded bg-green-600 text-white font-semibold text-sm"
                    onClick={handleStart}
                    aria-label="Start Test"
                    disabled={isClosing}
                  >
                    {isClosing ? "Starting..." : "Start Test"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Root>
    );
  };

  // Add state for precautions popup

  return (
    <Observer>
      {() => (
        <>
          <PrecautionsPopup
            open={PopupStore.showPrecautions}
            onClose={() => {
              PopupStore.setShowPrecautions(false);
              startTour();
            }}
            onStart={async () => {
              PopupStore.setShowPrecautions(false);
              startTour();
            }}
          />
          <RequestPermission
            popUpInitialValue={PopupStore.requestPermissionPopUp}
            handlePopup={() => {
              PopupStore.setRequestPermissionPopUp(false);
            }}
            screenRecord={true}
            handleStartRecord={() => {
              startRecording();
              setRecordPermissionByUser(true);
              InterviewStore.setRecordPermission(true);
              PopupStore.setRequestPermissionPopUp(false);
            }}
          />
          <UploadLoader
            load={InterviewStore.VideoUpload}
            mess={"Uploading"}
            count={InterviewStore.VideoUploadProgress.toFixed(0)}
          />
          {/* <RequestPermission
            popUpInitialValue={PopupStore.requestPermission}
            handlePopup={() => {
              checkPermission()
              PopupStore.setRequestPermission(false);
            }}
            screenRecord={PopupStore.microPhone}
          /> */}
          {PopupStore.referAndEarn && (
            <ReferAndEarn
              popUpInitialValue={PopupStore.referAndEarn}
              handlePopup={() => {
                PopupStore.setReferAndEarn(false);
              }}
            />
          )}

          <div
            className="md:w-[70%] lg:w-[70%] w-full min-h-[93vh] max-h-[93vh] md:min-h-[87vh] md:max-h-[100vh] flex flex-col items-center justify-between px-[1%] rounded-lg"
            style={{
              background: theme === "dark" ? "#000" : "#fff",
              boxShadow: theme === "dark" ? "" : "0 2px 8px 0 rgba(0,0,0,0.18)",
            }}
          >
            {/* {OffCameraPopUp && <CameraPopUp />} */}
            {showFeedbackForm ? feedbackForm() : null}
            {/* <CountdownTimer /> */}
            <div
              className="flex flex-row items-center justify-between w-full"
              id="interview"
            >
              {/* <div className="flex flex-row justify-between items-center w-full">
                <div className="flex items-center gap-2 flex-row">
                  {!isUser && (
                    <Tooltip
                      id="backtooltip"
                      position="bottom"
                      content="Back to dashboard"
                    >
                      <div
                        onClick={() => {
                          onBack();
                        }}
                        className="w-[40px] h-[40px] bg-slate-200 rounded-lg relative flex flex-row items-center justify-center cursor-pointer hover:bg-gray-500"
                      >
                        <MdOutlineArrowBackIosNew
                          onClick={() => {
                            onBack();
                          }}
                          className="w-[20px] h-[20px] text-slate-400 p-0  "
                        />
                      </div>
                    </Tooltip>
                  )}

                  <img
                    className="md:h-[29px] lg:h-[37px] hidden md:block lg:block  p-1"
                    src={getLogoBySubdomain(true)}
                    alt=""
                  />
                </div>

                {/* <audio ref={audioRef} controls className="mt-4"></audio> */}
              {/* <div className="relative flex-grow flex items-center justify-end">
                  {continueInterviewId && name1 === "" ? (
                    <p className="lg:text-3xl text-lg md:text-2xl gil-bold ml-[6%] lg:ml-0 md:ml-0 leading-5 whitespace-nowrap overflow-hidden text-ellipsis max-w-full md:max-w-[60%]">
                      Continue Interview
                    </p>
                  ) : (
                    <p className="lg:text-3xl text-lg md:text-2xl gil-bold ml-[6%] lg:ml-0 md:ml-0 leading-5 whitespace-nowrap overflow-hidden text-ellipsis max-w-full md:max-w-[60%]">
                      Interview on {(technology ?? tech).slice(0, 10)}... -{" "}
                      {(name ?? name1).split(" ")[0]}
                    </p>
                  )}
                </div> */}
              {/* <button
                  className="bg-primary text-white rounded-lg px-4 py-2 text-sm md:text-lg lg:text-xl"
                  onClick={() => PopupStore.setPopup(true)}
                >
                  show Pop up
                </button> */}
              {/* </div> */}
              {/* <AiOutlineMessage
                onClick={toggleMessageTab}
                className="text-3xl text-primary cursor-pointer md:hidden lg:hidden block"
              /> */}
            </div>
            {/* <hr className="border-0 bg-gray-300 h-px w-full" /> */}

            {/* Record time section */}
            <div
              className={`w-full relative ${
                !isInterviewCompleted && InterviewStore.chatHistory?.length > 2
                  ? "h-auto mt-3"
                  : ""
              } flex my-1 items-center justify-center`}
            >
              {/* <div className="w-[45%]">
                {isInterviewCompleted && !isVideoUploaded && (
                  <div
                    className="flex  items-center justify-center bg-amber-100 w-fit rounded-lg gil-med py-2 px-4  text-sm text-amber-400"
                    role="alert"
                  >
                    <AiOutlineClockCircle size="1.2rem" className="mr-2" />
                    Your video is uploading...
                  </div>
                )}
                {isVideoUploaded && recordPermissionByUser && (
                  <div
                    className="flex items-center justify-center bg-green-100 rounded-lg py-2 px-4 w-fit gil-med text-sm text-green-700"
                    role="alert"
                  >
                    <AiOutlineCheckCircle size="1.2rem" className="mr-2" />
                    Your video is uploaded
                  </div>
                )}
              </div> */}
              {/* {!isInterviewCompleted &&
              InterviewStore.chatHistory?.length > 2 ? (
                <div className="flex absolute right-0 flex-row w-full items-center justify-end">
                  <p
                    className=" text-red-600 flex items-center gap-2 border border-red-600 p-0.5 px-4 mb-1 rounded-lg text-sm cursor-pointer opacity-70"
                    onClick={manualInterviewCompleted}
                  >
                    <RiRecordCircleLine />
                    Stop interview
                  </p>
                </div>
              ) : null} */}
              {/* {RecordingSection(
                interviewStarted,
                isInterviewCompleted,
                recordPermissionByUser
              )} */}
            </div>

            {!showCountDownTimer ? (
              <Flex
                direction="column"
                align="center"
                justify="center"
                className="w-full h-[75%] border border-gray-500 border-opacity-40 rounded-lg"
                style={{
                  background: theme === "dark" ? "#000" : "#fff",
                }}
              >
                <Flex
                  direction="row"
                  align="center"
                  justify="center"
                  style={{
                    width: "100%",
                    height: "100%",
                    background: theme === "dark" ? "#000" : "#fff",
                    borderRadius: 24,
                    padding: window.innerWidth < 768 ? 4 : 16,
                    gap: 32,
                  }}
                >
                  {/* User Video/Avatar Card */}
                  <Box
                    style={{
                      flex: 1,
                      background: theme === "dark" ? "#000" : "#fff",
                      overflow: "hidden",
                      borderRadius: 24,
                      minHeight: "50vh",
                      maxHeight: "50vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      marginRight: 16,
                      overflow: "hidden",
                      display: window.innerWidth < 768 ? "none" : "flex",
                    }}
                    className=" rounded-lg"
                  >
                    {isCameraOn ? (
                      <UserVideo videoRef={videoRef} audioStatus={isMutedd} />
                    ) : (
                      <>
                        <Box
                          style={{
                            position: "relative",
                            width: "100%",
                            minHeight: "50vh",
                            maxHeight: "50vh",
                          }}
                        >
                          <Avatar
                            src={InterviewStore.userPic}
                            fallback="U"
                            size="8"
                            style={{
                              width: "100%",
                              height: "50vh",
                              borderRadius: "5%",
                            }}
                          />
                          <AudioVisualizer
                            start={InterviewStore.voiceVisualizer && isMutedd}
                          />
                        </Box>
                      </>
                    )}
                    {/* Optionally add a pause/play button here if needed */}
                  </Box>
                  {/* Interviewer Avatar Card */}
                  <Box
                    style={{
                      flex: 1,
                      background: theme === "dark" ? "#000" : "#fff",
                      borderRadius: window.innerWidth < 768 ? "50%" : 24,
                      minHeight: window.innerWidth < 768 ? "25vh" : "50vh",
                      maxHeight: window.innerWidth < 768 ? "25vh" : "50vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      marginLeft: 16,
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      style={{
                        position: "relative",
                        width: "100%",
                        minHeight: window.innerWidth < 768 ? "25vh" : "50vh",
                        maxHeight: window.innerWidth < 768 ? "25vh" : "50vh",
                      }}
                      className="flex flex-col items-center justify-center"
                    >
                      <Avatar
                        src={getLucyImg()}
                        fallback="L"
                        size="8"
                        style={{
                          width: window.innerWidth < 768 ? "50%" : "100%",
                          height: "100%",
                          borderRadius: window.innerWidth < 768 ? "50%" : "5%",
                        }}
                      />
                      <AudioVisualizer start={speaking} />
                    </Box>
                    {/* Optionally add a pause/play button here if needed */}
                  </Box>
                </Flex>
                {/* chat component for mobile view */}
                <div
                  className={`${
                    InterviewStore.chatHistory.length === 0 ? "hidden" : ""
                  } md:hidden  w-[100vw]`}
                >
                  <ChatComponent
                    chat={InterviewStore.chatHistory}
                    theme={theme}
                    userPic={InterviewStore.userPic}
                  />
                </div>
                {/* TypewriterText or fixed space below cards */}

                <Box
                  style={{
                    width: "98%",
                    height: 60,

                    borderRadius: 12,
                    margin: "16px 16px 16px 16px",

                    display: window.innerWidth < 768 ? "none" : "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflowY: "auto",
                    position: "relative",
                    scrollbarWidth: "none", // Firefox
                  }}
                  className="hide-scrollbar border border-gray-500 border-opacity-40 rounded-lg"
                >
                  {showBotcc ? (
                    <div
                      style={{
                        width: "100%",
                        maxHeight: 56,
                        overflowY: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "0 12px",
                        color: theme === "dark" ? "#fff" : "#222",
                      }}
                      className="hide-scrollbar text-sm md:text-lg lg:text-3xl gil-med z-30   m-auto text-center"
                    >
                      <TypewriterText text={botCC} delay={60} />
                    </div>
                  ) : !botCC &&
                    !speaking &&
                    !isInterviewCompleted &&
                    isinterviewStarted ? (
                    <div className="flex justify-center  w-full">
                      <textarea
                        ref={mainTextareaRef}
                        id="cc-ref"
                        readOnly={InterviewStore.textRestriction}
                        onChange={onChangeCC}
                        onPaste={(e) => {
                          const pastedText = e.clipboardData.getData("text");
                          console.log(
                            "Pasted content in main textarea:",
                            pastedText,
                          );
                          const data = {
                            anomalyType: "textDetection",
                            proof: {
                              type: "text",
                              label: "Paste Event",
                              description: `User pasted content: ${pastedText}`,
                            },
                          };
                          if (interviewDetails?._id) {
                            InterviewStore.updateProxyByInterviewId(
                              interviewDetails?._id,
                              data,
                            );
                          }
                        }}
                        className="text-sm md:text-lg lg:text-3xl gil-med z-30   m-auto text-center  rounded-lg px-4  w-[95%] focus:outline-none"
                        style={{
                          resize: "none",
                          overflow: "auto",
                          scrollbarWidth: "none",
                          background: theme === "dark" ? "#000" : "#fff",
                          color: theme === "dark" ? "#fff" : "#222",
                        }}
                        onClick={() => {
                          if (InterviewStore.textRestriction) {
                            InterviewStore.setNotificationText(
                              "You can't type during the interview",
                            );
                            InterviewStore.setNotificationIcon(
                              <TbKeyboardOff />,
                            );
                            InterviewStore.setShowNotification(true);
                          }
                        }}
                        value={
                          "You: " +
                          InterviewStore.userVoiceInput +
                          InterviewStore.transcript
                        }
                      />
                      <div className=" absolute right-[0.5%] -mt-1 bottom-0 w-[10%] z-40">
                        {!botCC && !speaking ? (
                          <>
                            <div>
                              <MdKeyboardBackspace
                                // onClick={backSpace}
                                onClick={storeBackSpace}
                                className="absolute bottom-0.5 text-lg lg:text-4xl md:text-2xl right-1 rounded-xl z-30 hover:text-yellow text-slate-300 cursor-pointer"
                              />
                            </div>

                            <div>
                              <AiOutlineCloseSquare
                                onClick={resetTheTrasncription}
                                className="absolute bottom-7 lg:bottom-11 text-lg lg:text-4xl md:text-2xl right-1 rounded-xl z-30 hover:text-red-600 text-slate-300 cursor-pointer"
                              />
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                  ) : null}
                </Box>
                <style>{`
                  .hide-scrollbar::-webkit-scrollbar { display: none; }
                  .hide-scrollbar { scrollbar-width: none; -ms-overflow-style: none; }
                `}</style>
              </Flex>
            ) : (
              <div className="w-full h-[75vh] rounded-lg">
                <Timer interviewId={interviewDetails?._id} theme={theme} />
              </div>
            )}

            {PopupStore.paymentGateway && (
              <PurchaseCredits
                gateWay="phonePe"
                onClose={() => {
                  PopupStore.setPaymentGateway(false);
                }}
              />
            )}

            <hr className="border-0  " />
            <Separator size="4" className="mt-2 w-[102%]" />

            {/* control section  */}
            <div className="flex flex-row my-6 items-center justify-between w-[calc(100%-1.5rem)] pb-6 md:pb-0">
              {/* {volumeComponent()} */}
              {/* {volumeButton()} */}

              {settingsComponent()}

              {iconRowComponent()}

              {leaveMeetingButton()}
            </div>
            {/* {!isInterviewCompleted && InterviewStore.chatHistory?.length > 2 ? (
              <div className="flex flex-row w-full items-center justify-end">
                <p
                  className=" text-yellow-600 underline cursor-pointer opacity-70"
                  onClick={manualInterviewCompleted}
                >
                  Click here after interview completed
                </p>
              </div>
            ) : null} */}
          </div>
        </>
      )}
    </Observer>
  );

  function muteButtonForChrome() {
    return (
      <Flex
        direction="column"
        align="center"
        gap="4"
        className="mt-1 md:mt-3 mr-1 border border-red-500"
      >
        <IconButton
          id="mute-btn-chrome"
          size={window.innerWidth < 768 ? "2" : "4"}
          variant={"ghost"}
          color={"gray"}
          onClick={() => toggleMuted(!isMutedd)}
          style={{
            border: "1px solid rgba(204, 204, 204, 0.2)",
          }}
        >
          {isMutedd ? (
            <MdOutlineMic className="text-lg md:text-2xl lg:text-3xl" />
          ) : (
            <MdOutlineMicOff className="text-lg md:text-2xl lg:text-3xl" />
          )}
        </IconButton>
      </Flex>

      // <div className=" flex flex-col items-center">
      //   <div
      //     id="mute-btn"
      //     className={` border ${
      //       isMutedd ? "border-primary" : "border-gray-300"
      //     } p-3 md:p-4 lg:p-4 rounded-lg cursor-pointer`}
      //     onClick={() => toggleMuted(!isMutedd)}
      //   >
      //     {isMutedd ? (
      //       <MdOutlineMic className="text-primary text-lg md:text-2xl lg:text-3xl" />
      //     ) : (
      //       <MdOutlineMicOff className="text-gray-500 text-lg md:text-2xl lg:text-3xl" />
      //     )}
      //   </div>

      // </div>
    );
  }
}
